webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

/* harmony default export */ __webpack_exports__["a"] = ({
    get: function get(key) {
        try {
            return JSON.parse(localStorage.getItem(key));
        } catch (e) {}
    },
    set: function set(key, value) {
        try {
            localStorage.setItem(key, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value));
        } catch (e) {}
    },
    remove: function remove(key) {
        try {
            localStorage.removeItem(key);
        } catch (e) {}
    },
    clear: function clear() {
        try {
            localStorage.clear();
        } catch (e) {}
    }
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony export (immutable) */ __webpack_exports__["a"] = parseQuery;
/* unused harmony export parseString */
/* unused harmony export mapDirective */

function parseQuery(query) {
    var specialValues = {
        'null': null,
        'true': true,
        'false': false
    };
    if (!query) return {};
    if (typeof query !== "string") return query;

    var queryLength = query.length;
    if (query.substr(0, 1) === "{" && query.substr(-1) === "}") {
        return JSON.parse(query);
    }

    var queryArgs = query.split(/[,\&]/g);

    var result = {};

    queryArgs.forEach(function (arg) {
        var idx = arg.indexOf("=");
        if (idx >= 0) {
            var name = arg.substr(0, idx);
            var value = decodeURIComponent(arg.substr(idx + 1));
            if (specialValues.hasOwnProperty(value)) {
                value = specialValues[value];
            }
            if (name.substr(-2) === "[]") {
                name = decodeURIComponent(name.substr(0, name.length - 2));
                if (!Array.isArray(result[name])) result[name] = [];
                result[name].push(value);
            } else {
                name = decodeURIComponent(name);
                result[name] = value;
            }
        } else {
            if (arg.substr(0, 1) === "-") {
                result[decodeURIComponent(arg.substr(1))] = false;
            } else if (arg.substr(0, 1) === "+") {
                result[decodeURIComponent(arg.substr(1))] = true;
            } else {
                result[decodeURIComponent(arg)] = true;
            }
        }
    });
    return result;
};

function parseString(str) {
    try {
        if (str[0] === '"') return JSON.parse(str);
        if (str[0] === "'" && str.substr(str.length - 1) === "'") {
            return parseString(str.replace(/\\.|"/g, function (x) {
                if (x === '"') return '\\"';
                return x;
            }).replace(/^'|'$/g, '"'));
        }
        return JSON.parse('"' + str + '"');
    } catch (e) {
        return str;
    }
};

function normalizeMap(map) {
    return Array.isArray(map) ? map.map(function (key) {
        return { key: key, val: key };
    }) : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(map).map(function (key) {
        return { key: key, val: map[key] };
    });
}

function mapDirective(directive) {
    var normalized = normalizeMap(directive)[0];

    return [normalized.key, function () {
        return normalized.val;
    }];
}

/***/ }),
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/carregando-mensagens.7b20394.gif";

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/perfil.76fa900.png";

/***/ }),
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);


__WEBPACK_IMPORTED_MODULE_0_angular__["module"]('app.components', []);

__webpack_require__(304);
__webpack_require__(305);
__webpack_require__(306);
__webpack_require__(307);
__webpack_require__(308);
__webpack_require__(312);
__webpack_require__(313);
__webpack_require__(314);
__webpack_require__(316);
__webpack_require__(320);
__webpack_require__(322);
__webpack_require__(317);
__webpack_require__(318);
__webpack_require__(319);
__webpack_require__(315);
__webpack_require__(321);
__webpack_require__(310);

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_compartilhado_plugins_log_events_plugin__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_simditor_js__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_angular_animate__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_angular_animate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_angular_animate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_angular_cookies__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_angular_cookies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_angular_cookies__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_angular_drop_image__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_angular_drop_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_angular_drop_image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_angular_i18n_pt_br__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_angular_i18n_pt_br___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_angular_i18n_pt_br__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_angular_notification__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_angular_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_angular_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_angular_resource__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_angular_resource___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_angular_resource__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_angular_route__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_angular_route___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_angular_route__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_angular_sanitize__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_angular_sanitize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_angular_sanitize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_angular_strap__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_angular_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_angular_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_angular_ui_router__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_angular_ui_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_angular_ui_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_angular_ui_sortable__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_angular_ui_sortable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_angular_ui_sortable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_angular_paging__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_angular_paging___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_angular_paging__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_angular_loading_bar__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_angular_loading_bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_angular_loading_bar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_ngstorage__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_ngstorage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_ngstorage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_ui_select__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_ui_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_ui_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_ng_plugin__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_ng_plugin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_ng_plugin__);

window.$ = __webpack_require__(2);
window.jQuery = $;
window.moment = __webpack_require__(0);
window._ = __webpack_require__(16);
window.signalr = __webpack_require__(288);
window.toastr = __webpack_require__(298);
window.saveAs = __webpack_require__(261).saveAs;
























__WEBPACK_IMPORTED_MODULE_1_angular__["module"]('bootstrap', ['ngLocale', 'ui.router', 'ngResource', 'ngCookies', 'ngRoute', 'ngStorage', 'ngSanitize', 'ngDropImage', 'angular-loading-bar', 'angular-simditor', 'ui.sortable', 'notification', 'mgcrea.ngStrap', 'ui.select', 'bw.paging']);

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__central_app_config__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__central_app_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__central_app_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__central_constant__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__central_interceptors__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__central_interceptors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__central_interceptors__);




/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_util__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__icone__ = __webpack_require__(172);





__WEBPACK_IMPORTED_MODULE_0_angular__["module"]('app.directives', []).directive('icone', __WEBPACK_IMPORTED_MODULE_2__icone__["a" /* default */]);

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layout__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__autenticacao__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__abrir_chamado__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__detalhe_chamado__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__meus_chamados__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_compartilhado_plugins_ui_plugin__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_compartilhado_plugins_filters_plugin__ = __webpack_require__(323);











__WEBPACK_IMPORTED_MODULE_0_angular__["module"]('app.modules', ['layoutMdl', 'autenticacaoMdl', 'abrirChamadoMdl', 'detalheChamadoMdl', 'meusChamadosMdl']).use(__WEBPACK_IMPORTED_MODULE_6_compartilhado_plugins_ui_plugin__["a" /* default */], 'md').use(__WEBPACK_IMPORTED_MODULE_7_compartilhado_plugins_filters_plugin__["a" /* default */]);

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);


__WEBPACK_IMPORTED_MODULE_0_angular__["module"]('app.services', []);

__webpack_require__(329);
__webpack_require__(328);
__webpack_require__(327);
__webpack_require__(330);

__webpack_require__(197);
__webpack_require__(198);
__webpack_require__(199);
__webpack_require__(200);
__webpack_require__(201);
__webpack_require__(202);
__webpack_require__(203);
__webpack_require__(204);

/***/ }),
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bootstrap = angular.module('bootstrap');

bootstrap.run(balcaoRun);
bootstrap.config(centralConfig);

centralConfig.$inject = ['$stateProvider', '$urlRouterProvider', '$localStorageProvider', '$httpProvider', '$sessionStorageProvider', '$locationProvider', 'cfpLoadingBarProvider', 'ngSimditorProvider', '$animateProvider'];

function centralConfig($stateProvider, $urlRouterProvider, $localStorageProvider, $httpProvider, $sessionStorageProvider, $locationProvider, cfpLoadingBarProvider, ngSimditorProvider, $animateProvider) {

    $animateProvider.classNameFilter(/animate/);

    ngSimditorProvider.setToolbar(['title', 'bold', 'italic', 'underline', 'alignments', 'strikethrough', '|', 'ol', 'ul', 'blockquote', 'code', 'table', '|', 'link', 'hr', '|', 'indent', 'outdent', 'markdown']).setLocale('pt-BR');

    $urlRouterProvider.otherwise("/login");

    $stateProvider.state('erro', {
        url: "/404",
        templateUrl: "404.html"
    });

    $localStorageProvider.setKeyPrefix('central-');
    $sessionStorageProvider.setKeyPrefix('central-');

    cfpLoadingBarProvider.includeSpinner = false;

    $httpProvider.interceptors.push('SuporteIeItp');

    $locationProvider.html5Mode({
        enabled: true,
        requireBase: true
    });

    moment.locale('pt-br');
}

balcaoRun.$inject = ['$rootScope', 'Usuario', '$state'];
function balcaoRun($rootScope, Usuario, $state) {

    $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {

        $state.previous = { state: fromState, params: fromParams };

        if (!Usuario.verificarAutorizacao()) {
            if (Usuario.estadoMemorizado && (!_.has(fromState.data, 'redirecionarPara') || toState.name != fromState.data.redirecionarPara)) {
                Usuario.resetarAutorizacao();
            }

            if (_.has(toState.data, 'autorizacao') && _.has(toState.data, 'redirecionarPara')) {
                if (_.has(toState.data, 'memorizar') && toState.data.memorizar) {
                    Usuario.estadoMemorizado = toState.name;
                }

                $state.go(toState.data.redirecionarPara);
                toastr.error('Acesso não autorizado', 'Autorização');
            }
        }
    });
}

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__central_app_env__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__central_app_env___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__central_app_env__);




angular.module('bootstrap').constant('ConfigApp', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["merge"])({
    UrlApi: "https://localhost:44341/ccgp/api",
    UrlBase: "https://localhost:44341/ccgp",
    CentralAppId: 'BA69D4DB-2657-4152-9E30-038B686E3E66',
    CentralServicoModuloId: 'F66F079C-5896-4AF2-B7D9-8060D80DDD71',
    UrlLogin: '#/login',
    UrlCstiApi: 'https://csti.projecao.br/api',
    CstiApiId: '02C7115C-E385-406C-8BBE-9015FC5CECF0',
    LinkFoto: function LinkFoto(login, tamanho) {

        var dimensao = tamanho || '240x240';

        return 'https://webmail.projecao.br/ews/exchange.asmx/s/GetUserPhoto?email=' + login + '@projecao.br&size=HR' + dimensao;
    }
}, __WEBPACK_IMPORTED_MODULE_1__central_app_env___default.a["production"]));

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('bootstrap').factory('SuporteIeItp', SuporteIeItp);

SuporteIeItp.$inject = [];

function SuporteIeItp() {
    return {
        request: function request(config) {

            config.headers = config.headers || {};

            return config;
        }
    };
}

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_simditor_styles_simditor_css__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_simditor_styles_simditor_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_simditor_styles_simditor_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_simditor_markdown_github_styles_simditor_markdown_github_css__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_simditor_markdown_github_styles_simditor_markdown_github_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_simditor_markdown_github_styles_simditor_markdown_github_css__);

window.Simditor = __webpack_require__(4);

__webpack_require__(290);
__webpack_require__(289);
__webpack_require__(291);
__webpack_require__(161);
__webpack_require__(220);




/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_util__ = __webpack_require__(12);
/* harmony export (immutable) */ __webpack_exports__["a"] = icon;


function icon() {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            css: '@'
        },
        link: function link(scope, element, attrs) {
            var elem = $(element[0]);
            var i = attrs;

            if (i.fa) {
                elem.addClass('fa fa-' + i.fa);
            }

            if (i.spin || i.spin == '') {
                if (i.fa) elem.addClass('fa-spin');
                if (i.fp) elem.addClass('fp-spin');
            }

            if (i.size) {
                if (i.fa) elem.addClass('fa-' + i.size + 'x');
                if (i.fp) elem.addClass('fp-' + i.size + 'x');
            }

            if (i.fp) {
                elem.addClass('fp fp-' + i.fp);
            }

            if (i.bo) {
                elem.addClass('glyphicon glyphicon-' + i.bo + ' ' + i.class);
            }

            if (i.rotate) {
                elem.css({ 'transform': 'rotate(' + i.rotate + 'deg)' });
            }

            if (i.css) {

                if (!!i.css) {
                    scope.$watch('css', function (css) {
                        elem.css(__WEBPACK_IMPORTED_MODULE_0__core_util__["a" /* parseQuery */](css));
                    });
                }

                elem.css(__WEBPACK_IMPORTED_MODULE_0__core_util__["a" /* parseQuery */](i.css));
            }
        },
        template: '<i aria-hidden="true"></i>'
    };
}

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_bootstrap__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_config__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__directives__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_bootstrap__);









window.app = angular.module('app', ['bootstrap', 'app.components', 'app.directives', 'app.services', 'app.modules']);

angular.bootstrap(document, ['app'], {
  strictDi: true
});

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var abrirChamadoMdl = angular.module('abrirChamadoMdl', []);
abrirChamadoMdl.config(abrirChamadoConfig);
abrirChamadoConfig.$inject = ['$stateProvider'];

function abrirChamadoConfig($stateProvider) {

    $stateProvider.state('app.abrir-chamado-segmentos', {
        url: '/abrir-chamado-segmentos/:grupoDeSuporteId/:grupoDeSuporteSegmentoId',
        controller: 'abrirChamadoSegmentosCtrl',
        controllerAs: '$ctrl',
        template: __webpack_require__(262),
        data: {
            autorizacao: true,
            redirecionarPara: 'autenticacao.login'
        }
    }).state('app.abrir-chamado', {
        url: '/abrir-chamado/grupos-suporte/:grupoDeSuporteId/grupos-suporte-segmentos/:grupoDeSuporteSegmentoId',
        controller: 'abrirChamadoCtrl',
        controllerAs: '$ctrl',
        template: __webpack_require__(263),
        data: {
            autorizacao: true,
            redirecionarPara: 'autenticacao.login'
        }
    });
}

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var abrirChamadoMdl = angular.module('abrirChamadoMdl');
abrirChamadoMdl.controller('abrirChamadoCtrl', abrirChamadoCtrl);

abrirChamadoCtrl.$inject = ['$state', '$stateParams', 'Event', 'notificacao', 'categorizacoesApi', 'chamadosApi', '$sessionStorage'];

function abrirChamadoCtrl($state, $stateParams, Event, notificacao, categorizacoesApi, chamadosApi, $sessionStorage) {

    var $ctrl = this;

    $ctrl.data = new Date();
    $ctrl.chamado = {};
    $ctrl.segmentoParametros = $stateParams;
    $ctrl.abrirChamado = abrirChamado;
    $ctrl.colar = colar;
    $ctrl.api = null;
    $ctrl.unidades = [];
    var credencial = $sessionStorage.credencial.data.credencial;

    categorizacoesApi.listarImpactos(function (impactos) {
        $ctrl.impactos = impactos;
    }, function (erros) {
        notificacao.erroResponse(erros);
    });

    categorizacoesApi.listarUrgencias(function (urgencias) {
        $ctrl.urgencias = urgencias;
    }, function (erros) {
        notificacao.erroResponse(erros);
    });

    function abrirChamado(chamado) {

        var formChamado = new FormData();

        formChamado.append('grupoDeSuporteSegmentoId', $stateParams.grupoDeSuporteSegmentoId);
        formChamado.append('aberturaAssunto', chamado.assunto);
        formChamado.append('impactoSolicitanteId', chamado.impactoSolicitante.impactoId);
        formChamado.append('urgenciaSolicitanteId', chamado.urgenciaSolicitante.urgenciaId);
        formChamado.append('aberturaUnidade', chamado.aberturaUnidade);
        formChamado.append('aberturaMensagem', _.escape(chamado.mensagem.replace(/'/g, '"')));

        _.each(chamado.anexos, function (anexo) {
            formChamado.append('Files[]', anexo, anexo.name);
        });

        $ctrl.api = chamadosApi.abrirChamado(formChamado, function (response) {

            notificacao.sucesso('<i class="fa fa-ticket" style="color: #ffffff;"></i> Ticket de Abertura de Chamado', 'Chamado registrado com o Ticket Nº. ' + response.ticket);

            $state.go('app.meus-chamados');
        }, function (erros) {

            if (erros.data) {
                notificacao.erroResponse(erros);
            } else {
                notificacao.erro('Erro durante o envido do chamado, por gentileza tente novamente.');
            }
        }).$promise;
    }
    chamadosApi.unidades(function (unidades) {
        $ctrl.unidades = unidades;
        $ctrl.chamado.aberturaUnidade = credencial.registroAd.unidade;
    }, function (erros) {
        notificacao.erroResponse(erros);
    });

    function colar($event) {

        Event.fire('anexo.colar-arquivo', $event);
    }
}

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var abrirChamadoMdl = angular.module('abrirChamadoMdl');
abrirChamadoMdl.controller('abrirChamadoSegmentosCtrl', abrirChamadoSegmentosCtrl);

abrirChamadoSegmentosCtrl.$inject = ['$scope', '$filter', '$state', '$stateParams', '$sessionStorage', '$localStorage', 'notificacao', 'segmentosApi'];

function abrirChamadoSegmentosCtrl($scope, $filter, $state, $stateParams, $sessionStorage, $localStorage, notificacao, segmentosApi) {
    $scope.segmento = {};
    $scope.history = window.history;
    $scope.showForward = false;
    $scope.segmentos = $sessionStorage.segmentos || [];
    $scope.carregarSegmentos = carregarSegmentos;
    $scope.acessarSegmento = acessarSegmento;
    $scope.alternarTipoLista = alternarTipoLista;
    $scope.retornar = $state.previous;
    $scope.atualizarSegmentos = atualizarSegmentos;

    $scope.$storage = $localStorage.$default({
        tipoListaSegmento: 0
    });

    if ($scope.segmentos.length == 0) {
        $scope.carregarSegmentos();
    }

    if (!_.isEmpty($stateParams.grupoDeSuporteId)) {
        var params = _.omitBy($stateParams, _.isEmpty);

        $scope.segmento = _.first($filter('buscar')($scope.segmentos, params));

        $scope.segmentos = $scope.segmento.segmentos;
    }

    function carregarSegmentos() {
        return segmentosApi.listarSegmentos(function (segmentos) {
            $scope.segmentos = segmentos;
            $sessionStorage.segmentos = segmentos;
        }, function error(errorResponse) {
            notificacao.erroResponse(errorResponse);
        });
    }

    function acessarSegmento(segmento) {
        if (_.isEqual(segmento.segmentos.length, 1) && !_.isNull(_.first(segmento.segmentos).canalDeAtendimentoId)) {
            $state.go('app.abrir-chamado', {
                grupoDeSuporteId: segmento.grupoDeSuporteId,
                grupoDeSuporteSegmentoId: segmento.segmentos[0].grupoDeSuporteSegmentoId
            });
        } else if (segmento.canalDeAtendimentoId != null) {
            $state.go('app.abrir-chamado', {
                grupoDeSuporteId: segmento.grupoDeSuporteId,
                grupoDeSuporteSegmentoId: segmento.grupoDeSuporteSegmentoId
            });
        } else {
            $state.go('app.abrir-chamado-segmentos', {
                grupoDeSuporteId: segmento.grupoDeSuporteId,
                grupoDeSuporteSegmentoId: segmento.grupoDeSuporteSegmentoId
            });
        }
    }

    function alternarTipoLista(tipo) {
        $scope.$storage.tipoListaSegmento = tipo;
    }

    function atualizarSegmentos() {
        $scope.carregarSegmentos().$promise.then(function () {
            notificacao.sucesso('Cartões atualizados!');
        });
    }
}

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__abrir_chamado_config__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__abrir_chamado_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__abrir_chamado_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__abrir_chamado_controller__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__abrir_chamado_controller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__abrir_chamado_controller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__abrir_chamado_segmentos_controller__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__abrir_chamado_segmentos_controller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__abrir_chamado_segmentos_controller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__abrir_chamado_css__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__abrir_chamado_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__abrir_chamado_css__);






/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var autenticacaoMdl = angular.module('autenticacaoMdl', []);

autenticacaoMdl.config(['$stateProvider', function ($stateProvider) {

  $stateProvider.state('autenticacao', {
    abstract: true,
    template: '<ui-view></ui-view>'
  }).state('autenticacao.login', {
    url: "/login",
    controller: 'autenticacaoCtrl',
    template: __webpack_require__(264)
  });
}]).config(['$httpProvider', function ($httpProvider) {
  $httpProvider.interceptors.push('AutenticacaoItp');
}]);

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var auteticacaoMdl = angular.module('autenticacaoMdl');
auteticacaoMdl.controller('autenticacaoCtrl', autenticacaoCtrl);

autenticacaoCtrl.$inject = ['$scope', '$state', 'Usuario', '$modal'];

function autenticacaoCtrl($scope, $state, Usuario, $modal) {

    $scope.usuario = {};
    $scope.anoAtual = new Date();

    var recuperacaoSenhaId;
    $scope.buscarTexto = function () {
        Usuario.recuperarSenha().then(function (response) {
            recuperacaoSenhaId = response.data.recuperacaoSenhaId;
            $scope.modal = $modal({
                scope: $scope,
                title: response.data.titulo,
                content: response.data.mensagem,
                show: true,
                html: true,
                backdrop: false,
                template: __webpack_require__(265)
            });
        }, function () {});
    };

    $scope.fecharModal = function () {
        Usuario.recuperarSenhaContabilizar(recuperacaoSenhaId).then(function (response) {
            $scope.modal.hide();
        }, function () {});
    };

    $scope.login = function (usuario) {

        Usuario.login(usuario).then(function () {

            Usuario.irPara('app.meus-chamados');
        }, function () {
            toastr.error("Você não possui permissão de acesso", 'Autenticação');
        });
    };
};

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var autenticacaoMdl = angular.module('autenticacaoMdl');
autenticacaoMdl.factory('AutenticacaoItp', autenticacaoItp);
autenticacaoItp.$inject = ['$cookies', 'ConfigApp', '$injector', '$q'];

function autenticacaoItp($cookies, ConfigApp, $injector, $q) {
    return {
        request: function request(config) {
            config.headers = config.headers || {};
            var token = $cookies.get('api_token');

            if (!(config.url.indexOf(ConfigApp.UrlApi + '/token') === 0) && token) {
                config.headers.Authorization = 'Bearer ' + $cookies.get('api_token');
            }

            return config;
        },

        responseError: function responseError(rejection) {

            if (rejection.status == 401) {
                $cookies.remove('api_token');
                window.location = ConfigApp.UrlLogin;
            }

            if (rejection.status == 500) {
                toastr.error('Houve um erro interno, por gentileza informe ao setor responsável.', 'Erro 500');
            }

            return $q.reject(rejection);
        }
    };
}

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__autenticacao_config__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__autenticacao_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__autenticacao_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__autenticacao_controller__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__autenticacao_controller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__autenticacao_controller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__autenticacao_interceptor__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__autenticacao_interceptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__autenticacao_interceptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__usuario_service__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__usuario_service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__usuario_service__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__login_css__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__login_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__login_css__);







/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var autenticacaoMdl = angular.module('autenticacaoMdl');

autenticacaoMdl.service('Usuario', usuarioSrv);

usuarioSrv.$inject = ['$http', '$cookies', 'ConfigApp', '$timeout', '$state', '$sessionStorage', '$q', 'NotificacaoStream'];

function usuarioSrv($http, $cookies, ConfigApp, $timeout, $state, $sessionStorage, $q, NotificacaoStream) {

    this.autorizado = false;
    this.estadoMemorizado = null;
    this.autenticado = null;

    this.resetarAutorizacao = function () {
        this.autorizado = false;
        this.estadoMemorizado = null;
    };

    this.irPara = function (retirada) {
        this.autorizado = true;
        var estado = this.estadoMemorizado ? this.estadoMemorizado : retirada;
        $state.go(estado);
    };

    this.login = function (usuario) {
        var self = this;
        usuario.grant_type = 'password';

        var req = {
            method: 'POST',
            url: ConfigApp.UrlApi + '/token?sistemaId=' + ConfigApp.CentralAppId,
            headers: {
                'Authorization': undefined,
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            data: $.param(usuario)
        };

        return $http(req).then(function (response) {
            $timeout(function () {
                toastr.warning('Seu token expirou, por favor autentique novamente.', 'Autenticação');
                self.logout();
            }, response.data.expires_in * 3600);

            $cookies.put('api_token', response.data.access_token);
        }, function (error) {
            return $q.reject(error);
        });
    };

    this.logout = function () {
        this.resetarAutorizacao();

        $sessionStorage.$reset();
        $cookies.remove('api_token');
        window.location = ConfigApp.UrlLogin;
    };

    this.credencial = function () {
        var self = this,
            deferred = $q.defer();
        var credencial = $sessionStorage.credencial || this.autenticado;

        if (credencial) {
            deferred.resolve(credencial);
        }

        $http.get(ConfigApp.UrlApi + '/v1.0/seguranca/sistemas/' + ConfigApp.CentralAppId + '/credencial', {}, { ignoreLoadingBar: true }).then(function (credencial) {
            $sessionStorage.credencial = credencial;

            this.autenticado = credencial;

            NotificacaoStream.conectar().then(function () {

                angular.module('app').value('hubConnection', credencial.data.canaisDeAtendimento);

                NotificacaoStream.canais(credencial.data.canaisDeAtendimento).usuario(credencial.data.usuario);
            });

            deferred.resolve(credencial);
        }.bind(this));

        return deferred.promise;
    };

    this.verificarAutorizacao = function () {

        var credencial = $sessionStorage.credencial || true;

        if (credencial) {
            this.autorizado = true;
        }

        return this.autorizado;
    };

    this.recuperarSenha = function () {
        var self = this,
            deferred = $q.defer();

        $http.get(ConfigApp.UrlApi + '/v1.0/recuperar_senha', {}, { ignoreLoadingBar: true }).then(function (response) {
            deferred.resolve(response);
        }.bind(this));
        return deferred.promise;
    };

    this.recuperarSenhaContabilizar = function (recuperacaoSenhaId) {
        var self = this,
            deferred = $q.defer();
        $http.post(ConfigApp.UrlApi + '/v1.0/recuperar_senha/' + recuperacaoSenhaId, {}, { ignoreLoadingBar: true }).then(function (response) {
            deferred.resolve(response);
        }.bind(this));
        return deferred.promise;
    };
}

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var balcaoApp = angular.module('detalheChamadoMdl');
balcaoApp.factory('detalheChamadoApi', detalheChamadoSrv);
detalheChamadoSrv.$inject = ['$resource', 'ConfigApp'];

function detalheChamadoSrv($resource, ConfigApp) {
    return $resource(ConfigApp.UrlApi + '/v1.0/meus_chamados', {}, {
        verificarRespostas: {
            method: 'GET',
            isArray: true,
            url: ConfigApp.UrlApi + '/v1.0/chamados/:chamadoId/atendimentos/:chamadoAtendimentoId/respostas'
        },
        redirecionamentos: {
            method: 'GET',
            isArray: true,
            url: ConfigApp.UrlApi + '/v1.0/roteamentos/chamados/:chamadoId',
            params: { chamadoId: '@chamadoId' }
        }
    });
};

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var detalheChamadoMdl = angular.module('detalheChamadoMdl', []);
detalheChamadoMdl.config(detalheChamadoConfig);
detalheChamadoConfig.$inject = ['$stateProvider'];

function detalheChamadoConfig($stateProvider) {

    $stateProvider.state('app.detalhe-chamado', {
        url: "/meus-chamados/detalhe/:chamadoId",
        controller: 'detalheChamadoCtrl',
        controllerAs: '$ctrl',
        template: __webpack_require__(266),
        data: {
            autorizacao: true,
            redirecionarPara: 'autenticacao.login'
        }
    });
}

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var detalheChamadoMdl = angular.module('detalheChamadoMdl');
detalheChamadoMdl.controller('detalheChamadoCtrl', detalheChamadoCtrl);

detalheChamadoCtrl.$inject = ['$scope', '$filter', '$stateParams', 'notificacao', 'detalheChamadoApi', 'chamadosApi', 'categorizacoesApi', 'Event'];

function detalheChamadoCtrl($scope, $filter, $stateParams, notificacao, detalheChamadoApi, chamadosApi, categorizacoesApi, Event) {

    var $ctrl = this;

    $ctrl.buscarRedirecionamento = buscarRedirecionamento;
    $ctrl.atualizarChamado = atualizarChamado;
    $ctrl.carregar = carregar;
    $ctrl.redirecionamentos = [];
    $ctrl.dimensaoArquivos = 0;

    carregar();

    Event.on('chamado:atualizar', function (event, payload) {
        if (payload.chamadoId && payload.chamadoId == $ctrl.infoChamado.chamadoId) {
            $ctrl.atualizarChamado();
        }
    })($scope);

    function carregar() {
        $ctrl.chamado = chamadosApi.detalhesChamado({
            chamadoId: $stateParams.chamadoId
        }, function (infoChamado) {

            _.map(infoChamado.anexos, function (anexo) {
                anexo.ehImagem = /.png|png|.jpg|jpg|jpeg|.jpeg|.gif|gif/g.test(anexo.arquivoExtensao);
            });

            $ctrl.dimensaoArquivos = _.sumBy(infoChamado.anexos, 'arquivoTamanhoEmBytes');

            $ctrl.infoChamado = infoChamado;

            $ctrl.buscarRedirecionamento(infoChamado);

            return infoChamado;
        }, function (erros) {
            notificacao.erroResponse(erros);
        }).$promise;
    }

    function atualizarChamado() {
        $ctrl.carregar();
    }

    function buscarRedirecionamento(chamado) {
        detalheChamadoApi.redirecionamentos({
            chamadoId: chamado.chamadoId
        }, function (redirecionamento) {
            $ctrl.redirecionamentos = redirecionamento;
        }, function () {
            $ctrl.redirecionamentos = [];
        });
    }

    function colar($event) {

        Event.fire('anexo.colar-arquivo', $event);
    }
}

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__detalhe_chamado_config__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__detalhe_chamado_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__detalhe_chamado_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__detalhe_chamado_controller__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__detalhe_chamado_controller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__detalhe_chamado_controller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__detalhe_chamado_api_service__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__detalhe_chamado_api_service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__detalhe_chamado_api_service__);




/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_config__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layout_controller__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_footer_component__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_footer_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__layout_footer_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_head_component__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_sidebar_component__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_sidebar_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__layout_sidebar_component__);






/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_css__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__layout_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_compartilhado_plugins_menu_plugin__ = __webpack_require__(325);




var layoutMdl = angular.module('layoutMdl', []);



layoutMdl.config(layoutConfig).use(__WEBPACK_IMPORTED_MODULE_1_compartilhado_plugins_menu_plugin__["a" /* default */]);

layoutConfig.$inject = ['$stateProvider', '$datepickerProvider'];
function layoutConfig($stateProvider, $datepickerProvider) {
    $stateProvider.state('app', {
        abstract: true,
        template: __webpack_require__(270),
        controller: 'layoutCtrl'
    });

    angular.extend($datepickerProvider.defaults, {
        dateFormat: 'dd/MM/yyyy',
        startWeek: 1
    });
}

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_storage__ = __webpack_require__(11);




var MENU_KEY = 'layout:slide-menu';

var enabled = __WEBPACK_IMPORTED_MODULE_0__core_storage__["a" /* default */].get(MENU_KEY);

var layoutMdl = angular.module('layoutMdl');

layoutMdl.controller('layoutCtrl', layoutCtrl);

layoutCtrl.$inject = ['$scope'];
function layoutCtrl($scope) {

    $scope.menuLateral = true;
    $scope.menu = menu;

    function menu(aberto) {

        __WEBPACK_IMPORTED_MODULE_0__core_storage__["a" /* default */].set(MENU_KEY, aberto);

        $scope.menuLateral = aberto;

        if (aberto) {
            $("#sidebar").animate({ "left": "0" }, "slow");
        } else {
            $("#sidebar").animate({ "left": "-350px" }, "slow");
        }
    }

    $scope.$on('layout.alternar-menu', function (event, situacao) {
        $scope.menu(situacao);
    });

    $scope.$on('layout.alternar-menu.exibir', function () {
        $scope.menu(true);
    });

    $scope.$on('layout.alternar-menu.esconder', function () {
        $scope.menu(false);
    });

    $scope.$broadcast('layout.alternar-menu', enabled == null ? true : enabled);
}

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var layoutMdl = angular.module('layoutMdl');

layoutMdl.component('layoutFooter', {

    template: __webpack_require__(267)

});

footerCtrl.$inject = ['$scope', '$rootScope'];
function footerCtrl($scope, $rootScope) {}

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_storage__ = __webpack_require__(11);




var MENU_KEY = 'layout:slide-menu';

var enabled = __WEBPACK_IMPORTED_MODULE_0__core_storage__["a" /* default */].get(MENU_KEY);

var layoutMdl = angular.module('layoutMdl');

layoutMdl.component('layoutHeader', {

    template: __webpack_require__(268),
    controller: headCtrl

});

headCtrl.$inject = ['$scope', '$rootScope', 'Usuario', 'NotificacaoStream', 'notificacao', 'ConfigApp', 'Event'];
function headCtrl($scope, $rootScope, Usuario, NotificacaoStream, notificacao, ConfigApp, Event) {

    $scope.logout = function () {
        Usuario.logout();
    };

    $scope.menu = enabled == null ? true : enabled;
    $scope.menuEscondido = $scope.menu;

    $scope.alternarMenu = function () {
        $scope.$emit('layout.alternar-menu', $scope.menuEscondido = !$scope.menuEscondido);
    };

    $scope.$on('layout.alternar-menu', function (event, aberto) {
        $scope.menu = aberto;
    });

    function mensagens(envelope) {
        if (Array.isArray(envelope.messages)) {

            envelope.messages.forEach(function (message) {
                notificacao.notificar({
                    titulo: message.Key,
                    mensagem: message.Value,
                    tipo: message.type,
                    driver: 'desktop'
                });
            });
        };
    }

    NotificacaoStream.ouvir('chamadoAberto', function (envelope) {
        Event.fire('meus-chamados:atualizar');
        mensagens(envelope);
    });

    NotificacaoStream.ouvir('atendimentoIniciado', function (envelope) {
        Event.fire('meus-chamados:atualizar').fire('chamado:atualizar', envelope.payload);
        mensagens(envelope);
    });

    NotificacaoStream.ouvir('respostaEnviada', function (envelope) {
        Event.fire('meus-chamados:atualizar').fire('chat:atualizar', envelope.payload);
        mensagens(envelope);
    });
}

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var layoutMdl = angular.module('layoutMdl');

layoutMdl.component('layoutSidebar', {
    template: __webpack_require__(269)
});

sidebarCtrl.$inject = ['$scope', '$rootScope'];
function sidebarCtrl($scope, $rootScope) {}

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__meus_chamados_config__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__meus_chamados_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__meus_chamados_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__meus_chamados_api_service__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__meus_chamados_api_service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__meus_chamados_api_service__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__meus_chamados_controller__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__meus_chamados_controller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__meus_chamados_controller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_css__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_css__);






/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var balcaoApp = angular.module('meusChamadosMdl');
balcaoApp.factory('meusChamadosApi', meusChamadosSrv);
meusChamadosSrv.$inject = ['$resource', 'ConfigApp'];

function meusChamadosSrv($resource, ConfigApp) {
    return $resource(ConfigApp.UrlApi + '/v1.0/meus_chamados', {}, {
        listarMeusChamados: {
            method: 'GET',
            isArray: false,
            url: ConfigApp.UrlApi + '/v1.0/meus_chamados'
        }
    });
};

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var meusChamadosMdl = angular.module('meusChamadosMdl', []);
meusChamadosMdl.config(meusChamadosConfig).run(['$templateCache', function ($templateCache) {
    $templateCache.put('meus-chamados/_lista-visao-alternativa01.html', __webpack_require__(271));
    $templateCache.put('meus-chamados/_lista-visao-default.html', __webpack_require__(272));
    $templateCache.put('meus-chamados/_paginacao.html', __webpack_require__(273));
}]);
meusChamadosConfig.$inject = ['$stateProvider'];

function meusChamadosConfig($stateProvider) {

    $stateProvider.state('app.meus-chamados', {
        url: "/meus-chamados",
        controller: 'meusChamadosCtrl',
        controllerAs: '$ctrl',
        template: __webpack_require__(274),
        data: {
            autorizacao: true,
            redirecionarPara: 'autenticacao.login'
        }
    });
}

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var meusChamadosMdl = angular.module('meusChamadosMdl');
meusChamadosMdl.controller('meusChamadosCtrl', meusChamadosCtrl);

meusChamadosCtrl.$inject = ['$scope', '$filter', '$localStorage', 'notificacao', 'categorizacoesApi', 'meusChamadosApi', 'Event'];

function meusChamadosCtrl($scope, $filter, $localStorage, notificacao, categorizacoesApi, meusChamadosApi, Event) {

    var $ctrl = this;

    $ctrl.paginaAtual = 1;

    $ctrl.totalRegistrosEncontrados = 0;
    $ctrl.limiteMensagem = 130;

    $ctrl.buscarMeusChamados = _.debounce(buscarMeusChamados, 100);
    $ctrl.alternarTipoLista = alternarTipoLista;
    $ctrl.atualizarPagina = atualizarPagina;
    $ctrl.atualizar = atualizar;
    $ctrl.buscando = {};
    $ctrl.chamados = [];
    $ctrl.pesquisa = {};
    $ctrl.$storage = $localStorage.$default({
        tipoListaChamado: 'lista-visao-default',
        maximoRegistrosPorPagina: 5
    });
    $ctrl.maximoRegistrosPorPagina = $ctrl.$storage.maximoRegistrosPorPagina;

    categorizacoesApi.listarSituacoes(function (situacoes) {
        $ctrl.situacoes = situacoes;
    }, function (erros) {
        notificacao.erroResponse(erros);
    });

    categorizacoesApi.listarCanaisDeAtendimento(function (canaisDeAtendimento) {
        $ctrl.canaisDeAtendimento = canaisDeAtendimento;
    }, function (erros) {
        notificacao.erroResponse(erros);
    });

    $ctrl.buscarMeusChamados(1);

    Event.on('meus-chamados:atualizar', function () {
        $ctrl.buscarMeusChamados($ctrl.paginaAtual);
    })($scope);

    function buscarMeusChamados(page) {

        var parametros = _.merge(_.clone($ctrl.pesquisa), {
            pagina: page,
            maximoRegistrosPorPagina: $ctrl.maximoRegistrosPorPagina,
            dataInicio: normalizarData($ctrl.pesquisa.dataInicio),
            dataFim: normalizarData($ctrl.pesquisa.dataFim)
        });

        return $ctrl.buscando = meusChamadosApi.listarMeusChamados(_.omitBy(parametros, seNulo), function (resposta) {
            _.map(resposta.registrosEncontrados, function (registro) {
                registro.totalAnexo = _.sumBy(registro.contadorAnexos, 'quantidade');
            });

            $ctrl.chamados = resposta.registrosEncontrados;
            $ctrl.paginaAtual = resposta.pagina;
            $ctrl.totalRegistrosEncontrados = resposta.totalRegistrosEncontrados;
            $ctrl.maximoRegistrosPorPagina = resposta.maximoRegistrosPorPagina;
        }, function (erros) {

            $ctrl.chamados = [];
            $ctrl.paginaAtual = 1;
            $ctrl.totalRegistrosEncontrados = 0;

            notificacao.erroResponse(erros);
        }).$promise;
    }

    function atualizarPagina() {
        $ctrl.$storage.maximoRegistrosPorPagina = $ctrl.maximoRegistrosPorPagina;

        $ctrl.buscarMeusChamados(1);
    }

    function seNulo(valor) {
        return !valor;
    }

    function normalizarData(data) {
        return _.isDate(data) ? data.toISOString().slice(0, 10) : null;
    }

    function alternarTipoLista() {

        if ($ctrl.$storage.tipoListaChamado == 'lista-visao-alternativa01') {
            $ctrl.$storage.tipoListaChamado = 'lista-visao-default';
        } else {
            $ctrl.$storage.tipoListaChamado = 'lista-visao-alternativa01';
        }
    }

    function atualizar() {

        $ctrl.buscarMeusChamados($ctrl.paginaAtual).then(function () {
            notificacao.sucesso('Sua lista de chamados foi atualizada.');
        }, function (erros) {
            notificacao.erroResponse(erros);
        });
    };
}

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var balcaoApp = angular.module('app.services');
balcaoApp.factory('anexoApi', anexoSrv);
anexoSrv.$inject = ['$resource', 'ConfigApp'];

function anexoSrv($resource, ConfigApp) {
    return $resource(ConfigApp.UrlApi + '/v1.0/anexos', {}, {
        baixarArquivo: {
            method: 'GET',
            isArray: false,
            url: ConfigApp.UrlApi + '/v1.0/anexos/:anexoId/chamados/:chamadoId/download',
            responseType: 'arraybuffer',
            interceptor: {
                response: function response(_response) {
                    _response.resource.headers = _response.headers();
                    _response.resource.data = _response.data;
                    return _response.resource;
                }
            }
        }
    });
};

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.services').factory('catalogoServicoApi', catalogoServicoApi);

catalogoServicoApi.$inject = ['$resource', 'ConfigApp'];

function catalogoServicoApi($resource, ConfigApp) {
    return $resource(ConfigApp.UrlApi + '/v1.0/catalogos_servicos', {}, {
        listarCategoriasAtendimento: {
            method: 'GET',
            isArray: true,
            url: ConfigApp.UrlApi + '/v1.0/catalogos_servicos/canais_atendimentos/:canalDeAtendimentoId/categorias_atendimentos',
            ignoreLoadingBar: true
        },
        listarCatalogosServico: {
            method: 'GET',
            isArray: true,
            url: ConfigApp.UrlApi + '/v2.0/catalogos_servicos/canais_atendimentos/:canalDeAtendimentoId/categorias_atendimentos/:categoriaDeAtendimentoId',
            ignoreLoadingBar: true
        }
    });
};

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var centralApp = angular.module('app.services');
centralApp.factory('categorizacoesApi', categorizacoesSrv);
categorizacoesSrv.$inject = ['$resource', 'ConfigApp'];

function categorizacoesSrv($resource, ConfigApp) {
    return $resource(ConfigApp.UrlApi + '/v1.0/categorizacoes', {}, {
        listarImpactos: {
            method: 'GET',
            isArray: true,
            url: ConfigApp.UrlApi + '/v1.0/categorizacoes/impactos',
            ignoreLoadingBar: true,
            cache: true
        },
        listarUrgencias: {
            method: 'GET',
            isArray: true,
            url: ConfigApp.UrlApi + '/v1.0/categorizacoes/urgencias',
            ignoreLoadingBar: true,
            cache: true
        },
        listarSituacoes: {
            method: 'GET',
            isArray: true,
            url: ConfigApp.UrlApi + '/v1.0/categorizacoes/situacoes',
            ignoreLoadingBar: true,
            cache: true
        },
        listarSituacoesEncerramento: {
            method: 'GET',
            isArray: true,
            url: ConfigApp.UrlApi + '/v1.0/categorizacoes/situacoes_encerramento',
            ignoreLoadingBar: true,
            cache: true
        },
        listarCanaisDeAtendimento: {
            method: 'GET',
            isArray: true,
            url: ConfigApp.UrlApi + '/v1.0/categorizacoes/centrais_servico/' + ConfigApp.CentralServicoModuloId + '/canais_atendimento',
            ignoreLoadingBar: true,
            cache: true
        }
    });
};

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.services').factory('chamadosApi', chamadosApi);

chamadosApi.$inject = ['$resource', 'ConfigApp'];

function chamadosApi($resource, ConfigApp) {
    return $resource(ConfigApp.UrlApi + '/v1.0/chamados', {}, {
        abrirChamado: {
            method: 'POST',
            url: ConfigApp.UrlApi + '/v1.0/chamados',
            headers: { 'Content-Type': undefined, enctype: 'multipart/form-data' }
        },
        detalhesChamado: {
            method: 'GET',
            isArray: false,
            url: ConfigApp.UrlApi + '/v1.0/chamados/:chamadoId/por_usuario'
        },
        unidades: {
            method: 'GET',
            isArray: true,
            url: ConfigApp.UrlApi + '/v1.0/unidades',
            ignoreLoadingBar: true,
            cache: true
        },
        responderAoAtendente: {
            method: 'POST',
            url: ConfigApp.UrlApi + '/v1.0/chamados/:chamadoId/chat_atendimento/mensagem_ao_atendente',
            params: { chamadoId: '@chamadoId' },
            headers: { 'Content-Type': undefined, enctype: 'multipart/form-data' }
        }
    });
};

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.services').service('Chat', chatService);

chatService.$inject = ['$resource', 'ConfigApp'];

function chatService($resource, ConfigApp) {
    return {
        mensagens: function mensagens() {
            return $resource(ConfigApp.UrlApi + '/v1.0/chamados/:chamadoId/chat_atendimento/mensagens?sistemaOrigemId=' + ConfigApp.CentralAppId, { chamadoId: '@chamadoId' }, {
                get: {
                    method: 'GET',
                    isArray: true
                }
            });
        },
        resposta: function resposta(params) {
            return $resource(ConfigApp.UrlApi + '/v1.0/chamados/:chamadoId/chat_atendimento/mensagens?origemParticipante=:origemParticipante', { chamadoId: '@chamadoId', origemParticipante: '@origemParticipante' }, {
                enviar: {
                    method: 'POST',
                    headers: { 'Content-Type': undefined, enctype: 'multipart/form-data' },
                    params: params
                }
            });
        }
    };
}

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.services').factory('colaboradoresApi', colaboradoresApi);

colaboradoresApi.$inject = ['$resource', 'ConfigApp'];

function colaboradoresApi($resource, ConfigApp) {
    return $resource(ConfigApp.UrlApi + '/v1.0/colaboradores', {}, {
        atendentesInicio: {
            method: 'GET',
            params: { canalDeAtendimentoId: '@canalDeAtendimentoId' },
            isArray: true,
            url: ConfigApp.UrlApi + '/v1.0/colaboradores/atendentes_inicio'
        },
        atendentesFim: {
            method: 'GET',
            params: { canalDeAtendimentoId: '@canalDeAtendimentoId' },
            isArray: true,
            url: ConfigApp.UrlApi + '/v1.0/colaboradores/atendentes_fim'
        }
    });
};

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.services').factory('roteamentoChamadoApi', roteamentoChamadoApi);

roteamentoChamadoApi.$inject = ['$resource', 'ConfigApp'];

function roteamentoChamadoApi($resource, ConfigApp) {
    return $resource(ConfigApp.UrlApi + '/v1.0/roteamentos', {}, {
        redirecionarPara: {
            method: 'POST',
            url: ConfigApp.UrlApi + '/v1.0/roteamentos/redirecionar/chamados/:chamadoId'
        },
        listarEnderecos: {
            method: 'GET',
            isArray: true,
            url: ConfigApp.UrlApi + '/v1.0/roteamentos/enderecos'
        },
        listarMotivos: {
            method: 'GET',
            isArray: true,
            url: ConfigApp.UrlApi + '/v1.0/roteamentos/motivos',
            cache: true
        }
    });
};

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.services').factory('sistemaApi', sistemaApiFactory);
sistemaApiFactory.$inject = ['$resource', '$sessionStorage', '$q', 'ConfigApp'];

function sistemaApiFactory($resource, $sessionStorage, $q, ConfigApp) {
    return {
        versao: function versao(params) {

            var defer = $q.defer();
            var versao = $sessionStorage.versao;

            if (versao) {
                defer.resolve(versao);
                return defer.promise;
            } else {
                return $resource(ConfigApp.UrlApi + '/v1.0/csti/sistemas/' + ConfigApp.CentralAppId + '/info', {}, { ignoreLoadingBar: true }).get(params).$promise.then(function (response) {
                    $sessionStorage.versao = response.data;

                    return $sessionStorage.versao;
                });
            }
        }
    };
}

/***/ }),
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */
/***/ (function(module, exports) {

var DateButton, _ref,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

DateButton = (function(_super) {
  __extends(DateButton, _super);

  function DateButton() {
    _ref = DateButton.__super__.constructor.apply(this, arguments);
    return _ref;
  }

  DateButton.prototype.name = 'date';

  DateButton.prototype.icon = 'none fa fa-clock-o';

  DateButton.prototype.htmlTag = 'span';

  DateButton.prototype.needFocus = false;

  DateButton.prototype._status = function() {};

  DateButton.prototype.command = function() {
    var $newBlock, $nextBlock, $rootBlock, $span;
    $rootBlock = this.editor.selection.rootNodes().first();
    $nextBlock = $rootBlock.next();
    if ($nextBlock.length > 0) {
      this.editor.selection.save();
    } else {
      $newBlock = $('<p/>').append(this.editor.util.phBr);
    }
    $span = $('<span/>').text(this._getDate()).insertAfter($rootBlock);
    if ($newBlock) {
      $newBlock.insertAfter($span);
      this.editor.selection.setRangeAtStartOf($newBlock);
    } else {
      this.editor.selection.restore();
    }
    return this.editor.trigger('valuechanged');
  };

  DateButton.prototype._getDate = function() {
    var day, fulldate, month, now, parse, time, year;
    now = new Date();
    day = now.getDate();
    month = now.getMonth() + 1;
    year = now.getFullYear();
    parse = function(n) {
      if (n > 9) {
        return n;
      } else {
        return "0" + n;
      }
    };
    fulldate = [parse(day), parse(month), year].join('/');
    time = now.toString().match(/\d\d:\d\d:\d\d/)[0];
    return "" + fulldate + " " + time + " ";
  };

  return DateButton;

})(Simditor.Button);

Simditor.Toolbar.addButton(DateButton);


/***/ }),
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 250 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 251 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 252 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 253 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 254 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 255 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 256 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 257 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 258 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 259 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 260 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 261 */,
/* 262 */
/***/ (function(module, exports) {

module.exports = "<style>.altura-titulo{min-height:53px;height:auto!important;height:53px;padding-top:10px;margin-bottom:3px}</style> <div> <div class=titulo-pagina> <h2 class=text-muted> <i class=\"fa {{ segmento.imagem || 'fa-sitemap' }}\" aria-hidden=true></i> {{ segmentos.length ? (segmento.nome || 'Selecione um fornecedor de serviço') : 'Segmentos' }} <span class=pull-right style=width:180px> <div class=input-group> <input ng-model=pesquisa type=text class=form-control placeholder=\"Procurar por...\"> <span class=input-group-btn> <button class=\"btn btn-default\" type=button> <i class=\"fa fa-search text-muted\"></i> </button> </span> </div> </span> <span class=\"btn-group pull-right\" title=\"Clique para voltar\" role=group aria-label=... ng-if=segmentos.length> <a ng-if=history.length onclick=history.back() class=\"btn btn-default text-muted\"> <i class=\"fa fa-arrow-left text-muted\"></i> </a> <a ng-if=\"history.length < 1\" title=\"Clique para avançar\" onclick=history.forward() class=\"btn btn-default text-muted\"> <i class=\"fa fa-arrow-right text-muted\"></i> </a> <a ng-click=atualizarSegmentos() title=\"Clique para atualizar os cartões\" class=\"btn btn-default text-muted\"> <i class=\"fa fa-repeat text-muted\"></i> </a> <a ui-sref=app.abrir-chamado-segmentos({}) title=\"Clique para ir ao menu principal\" ui-sref-opts=\"{reload: true, inherit: false}\" class=\"btn btn-default text-muted\"> <i class=\"fa fa-home text-muted\"></i> </a> <button type=button class=\"btn btn-default\" title=\"Clique para exibir em forma de grade\" ng-class=\"{'active': $storage.tipoListaSegmento == 0}\" ng-click=alternarTipoLista(0)> <i class=\"fa fa-th-large text-muted\"></i> </button> <button type=button class=\"btn btn-default\" title=\"Clique para exibir em forma de lista\" ng-class=\"{'active': $storage.tipoListaSegmento == 1}\" ng-click=alternarTipoLista(1)> <i class=\"fa fa-th-list text-muted\"></i> </button> </span> </h2> </div> <div class=\"\" style=\"margin-top:-15px;padding:10px 10px 0 0;border-bottom:1px solid #ddd\" ng-if=segmentos.length md-scroll offset=115 id=segmentos> <div class=\"col-md-4 col-sm-6\" ng-repeat=\"segmento in segmentos | filter: pesquisa\" ng-if=\"$storage.tipoListaSegmento == 0\"> <div class=box-segmento-apps> <div class=text-center style=margin-bottom:20px> <i class=\"fa {{segmento.imagem || 'fa-puzzle-piece'}} fa-3x text-muted\"></i> </div> <div class=descricao> <div> <h5 class=\"text-muted text-center segmento-titulo altura-titulo\"> {{segmento.nome}} </h5> </div> <div ng-if=segmento.descricao class=\"text-muted segmento-descricao\"> <span ng-bind-html=segmento.descricao></span> </div> </div> <a class=\"btn btn-primary btn-lg\" style=width:100% ng-click=acessarSegmento(segmento)> <i class=\"fa fa-check\"></i> Abrir </a> </div> </div> <div class=col-md-12 ng-repeat=\"segmento in segmentos\" ng-if=\"$storage.tipoListaSegmento == 1\"> <div class=\"box-segmento-lista col-md-12 col-sm-12\"> <div class=\"col-md-1 col-sm-1 imagem\"> <i class=\"fa {{segmento.imagem || 'fa-puzzle-piece'}} fa-5x text-muted\"></i> </div> <div class=\"col-md-8 col-sm-8\"> <h4 class=text-muted><i class=\"fa fa-quote-left text-muted\" aria-hidden=true></i> {{segmento.nome}}</h4> <div ng-if=segmento.descricao class=\"text-muted segmento-descricao\"> <span ng-bind-html=segmento.descricao></span> </div> </div> <div class=\"col-md-2 col-sm-2 pull-right\"> <a class=\"btn btn-primary btn-lg pull-right\" style=width:100%;margin-top:20px ng-click=acessarSegmento(segmento)> <i class=\"fa fa-check\"></i> Abrir </a> </div> </div> </div> </div> <div class=row ng-if=!segmentos.length> <p class=\"text-muted text-center\" style=margin-top:20px> <i class=\"fa fa-info-circle fa-2x\" style=display:block></i> Nenhum cartão foi adicionado até o momento </p> </div> </div>";

/***/ }),
/* 263 */
/***/ (function(module, exports) {

module.exports = "<div> <div class=titulo-pagina> <h2 class=\"\"><i class=\"fa fa-commenting-o\" aria-hidden=true></i> Abrir Chamado</h2> </div> <div class=col-md-8> <painel titulo=\"Preenchimento de Informações\" icone=\"fa-pencil text-muted\" ng-paste=$ctrl.colar($event)> <form name=chamadoForm enctype=multipart/form-data ng-submit=$ctrl.abrirChamado($ctrl.chamado)> <div class=row> <div class=\"form-group col-md-12\"> <label>Assunto</label> <input ng-model=$ctrl.chamado.assunto type=text class=form-control style=min-width:100% placeholder=\"Informe um assunto que sintetize bem o que você deseja\" name=nome maxlength=100 ng-maxlength=100 ng-required=true /> </div> <div class=\"form-group col-md-6 input-icone\"> <label>Impacto</label> <select ng-model=$ctrl.chamado.impactoSolicitante ng-options=\"impacto.nome for impacto in $ctrl.impactos track by impacto.impactoId\" class=form-control name=impactos ng-required=true> <option value=\"\" disabled=disabled selected=selected>Qual o impacto em suas atividades?</option> </select> <span class=icone ng-if=$ctrl.chamado.impactoSolicitante.cor> <icone fa=circle css=\"color={{ $ctrl.chamado.impactoSolicitante.cor }}\"></icone> </span> </div> <div class=\"form-group col-md-6 input-icone\"> <label>Urgência</label> <select ng-model=$ctrl.chamado.urgenciaSolicitante ng-options=\"urgencia.nome for urgencia in $ctrl.urgencias track by urgencia.urgenciaId\" class=form-control name=urgencias ng-required=true> <option value=\"\" disabled=disabled selected=selected>Qual o seu nivel de urgência?</option> </select> <span class=icone ng-if=$ctrl.chamado.urgenciaSolicitante.cor> <icone fa=circle css=\"color={{ $ctrl.chamado.urgenciaSolicitante.cor }}\"></icone> </span> </div> <div class=\"form-group col-md-12 input-icone\"> <label>Sua Unidade</label> <select ng-model=$ctrl.chamado.aberturaUnidade ng-options=\"unidade for unidade in $ctrl.unidades\" class=form-control name=unidades ng-required=true> <option value=\"\" disabled=disabled selected=selected>Qual é a sua unidade?</option> </select> </div> <div class=\"form-group col-sm-12\"> <label class=control-label> Anexos: <span ng-if=$ctrl.chamado.anexos.length class=text-muted>({{ $ctrl.chamado.anexos.length }})</span> </label> <anexos arquivos=$ctrl.chamado.anexos dimensao=$ctrl.dimensao></anexos> </div> <div class=\"form-group col-md-12\"> <label>Mensagem</label> <ng-simditor class=simditor-help name=mensagem placeholder=\"Descreva o mais detalhadamente que você conseguir\" ng-model=$ctrl.chamado.mensagem ng-required=true ng-paste=$ctrl.colar(event)> </ng-simditor> </div> </div> <div class=text-right> <span class=\"text-muted pull-left text-extra\"> <a href=https://guides.github.com/features/mastering-markdown/#what target=_brank> <span class=\"simditor-icon simditor-icon-markdown\"></span> <small>Este editor suporta a sintaxe markdown</small> </a> </span> <a ui-sref=app.abrir-chamado-segmentos title=\"Cancelar chamado\" class=\"btn btn-default\"> <i class=\"fa fa-eraser text-muted\"></i> Cancelar </a> <button ng-disabled=chamadoForm.$invalid type=submit class=\"btn btn-primary\"> <i class=\"fa fa-paper-plane-o\"></i> Enviar </button> </div> </form> </painel> </div> <div class=col-md-4> <painel titulo=\"Complemento do Chamado\" icone=fa-sitemap> <segmento-selecionado parametros=$ctrl.segmentoParametros></segmento-selecionado> </painel> <painel titulo=Anexos icone=fa-paperclip subtitulo=\"{{ $ctrl.chamado.anexos.length || '' }}\"> <table class=\"table arquivos\" ng-if=$ctrl.chamado.anexos.length> <thead> <tr class=text-muted ng-repeat=\"anexo in $ctrl.chamado.anexos\"> <td title=\"Clique no icone para baixar o arquivo\"> <span ng-if=!anexo.ehImagem style=\"padding:3px 14px\"></span> <a href=\"\" class=\"btn text-success btn-sm\" ng-if=anexo.ehImagem visualizar-arquivo=anexo style=\"padding:3px 3px\"> <i class=\"fa fa-photo\" ng-class=\"{'carregando': anexo.abrindo}\"></i> </a> {{ anexo.name }} </td> <td class=\"dimensao text-right\"> <small class=ng-binding> {{ anexo.size | dimensaoArquivo }} </small> </td> </tr> <tr class=\"text-muted total\"> <th class=text-right> <small>Total: </small> </th> <th class=\"dimensao text-right\" style=\"padding:8px 0;white-space:nowrap\"> <small>{{ $ctrl.dimensao | dimensaoArquivo }}</small> </th> </tr> </thead> </table> <p ng-if=!$ctrl.chamado.anexos.length class=\"text-muted text-center\"> <i class=\"fa fa-info-circle\"></i> Nenhum arquivo anexado </p> </painel> </div> </div>";

/***/ }),
/* 264 */
/***/ (function(module, exports) {

module.exports = " <div class=prj-login> <div id=prj-background-branding-container> <img id=prj-image-background src=https://csti.projecao.br/autenticacao/imagem/fundo-default.jpg /> </div> <div id=prj-panel-sistema class=\"col-lg-6 col-md-7 col-sm-8 hidden-xs\"> <div id=prj-sistema-projecao class=row> <div class=\"col-md-12 col-sm-12 col-xs-12\"> <div class=\"col-md-12 col-sm-12 text-center caixa-nome-sistema\"> <h3 class=fundo-titulo>CCGP - Contact Center Grupo Projeção<br/>Módulo de Chamado</h3> </div> </div> </div> </div> <div id=prj-login-panel class=\"col-lg-6 col-md-5 col-sm-4 col-xs-12 prj-login-panel\"> <div id=prj-title-projecao class=container> <div> <img class=\"prj-image-footer img-responsive pull-left\" title=\"Logo Grupo Projeção\" alt=Projeção src=https://csti.projecao.br/autenticacao/imagem/projecao-default.png /> <img class=\"prj-image-footer img-responsive pull-right hidden-sm hidden-md hidden-lg\" src=https://csti.projecao.br/autenticacao/imagem/projecao-default.png alt=\"Central de Servi&#231;os de Tecnologia da Informa&#231;&#227;o\" title=\"Central de Servi&#231;os de Tecnologia da Informa&#231;&#227;o\"/> </div> </div> <div class=prj-login-panel-container> <div id=prj-panel-login-form class=\"col-md-offset-1 col-sm-offset-1 col-md-10 col-sm-10\"> <h1>Login</h1> <form id=formLogin name=formLogin ng-submit=login(usuario) class=loading method=post> <div class=\"input-group margin-bottom-sm\"> <span class=input-group-addon><i class=\"fa fa-user-o fa-fw\"></i></span> <input id=username name=username ng-model=usuario.username autofocus class=\"form-control input-lg\" type=text placeholder=Usuário> <span class=\"field-validation-valid help-inline text-danger\" data-valmsg-for=User data-valmsg-replace=true></span> </div> <br/> <div class=input-group> <span class=icon-caps-lock> <i class=\"fa fa-lock\"> </i> Caps Lock </span> <span class=input-group-addon><i class=\"fa fa-key fa-fw\"></i></span> <input id=password name=password ng-model=usuario.password class=\"form-control input-lg\" type=password placeholder=Senha md-caps-lock target=icon-caps-lock> <span class=\"field-validation-valid help-inline text-danger\" data-valmsg-for=Password data-valmsg-replace=true></span> </div> <br/> <div class=form-group> <button type=submit class=\"btn btn-lg btn-primary\"><i class=\"fa fa-sign-in\"></i> Entrar</button> <a class=prj-login-links href=\"\" ng-click=buscarTexto() data-toggle=modal data-target=#modalSenha>Esqueci minha senha</a> </div> </form> </div> </div> <div id=prj-logo-projecao class=container style=text-align:center;font-size:11px> <span>Setor de Desenvolvimento de Sistemas - Diretoria de Tecnologia da Informação - Grupo projeção &copy; {{::anoAtual|date: 'yyyy'}}</span> </div> </div> </div> ";

/***/ }),
/* 265 */
/***/ (function(module, exports) {

module.exports = "<div class=modal data-backdrop=false tabindex=-1 role=dialog aria-hidden=false> <div class=modal-dialog> <div class=modal-content> <div class=modal-header ng-show=title> <h4 class=modal-title><i class=\"fa fa-key text-muted\"></i> {{::title}}</h4> </div> <div class=modal-body ng-bind-html=::content> </div> <div class=modal-footer> <button type=button class=\"btn btn-default btn-success\" ng-click=fecharModal() aria-label=Close>Ok, Entendi!</button> </div> </div> </div> </div>";

/***/ }),
/* 266 */
/***/ (function(module, exports) {

module.exports = "<div class=\"\"> <div class=titulo-pagina> <h2> <i class=\"fa fa-ticket\" aria-hidden=true></i> Chamado: {{ ::$ctrl.infoChamado.ticket }} <span class=\"btn-group pull-right\" title=\"Clique para voltar\" role=group aria-label=...> <a onclick=history.back() class=\"btn btn-default text-muted\"> <i class=\"fa fa-arrow-left text-muted\"></i> </a> <a ui-sref=app.abrir-chamado-segmentos class=\"btn btn-primary\" style=margin-left:5px> <i class=\"fa fa-commenting-o\"></i> Abrir Novo Chamado </a> </span> </h2> </div> <style>.chamado-detalhe-info{margin-left:-15px;margin-right:-15px;margin-top:-15px;position:relative;height:35px}.chamado-detalhe-info .bloco{width:25%;float:left;position:relative;padding:10px 5px;border-bottom:1px solid #ddd}.chamado-detalhe-info .bloco:not(:last-child){border-right:1px solid #ddd}.chamado-detalhe-status{margin-left:-15px;margin-bottom:-15px;margin-top:15px;margin-right:-15px;border-top:1px solid #ddd;padding:10px 15px}</style> <script type=text/ng-template id=template/info-situacao.html> <div class=\"popover\" tabindex=\"-1\">\r\n            <div class=\"arrow\"></div>\r\n            <div class=\"popover-content\">\r\n               <span ng-if=\"$ctrl.infoChamado.chamadoAtendimento.iniciadoData && !$ctrl.infoChamado.chamadoAtendimento.AtendidoData\">\r\n                    O atendimento foi iniciado há {{ ::$ctrl.infoChamado.chamadoAtendimento.iniciadoData | tempoDecorrido }}\r\n               </span>\r\n            </div>\r\n        </div> </script> <div class=\"\"> <abas> <aba titulo=Chamado icone=\"fa fa-list\"> <div class=col-md-8> <painel titulo=\"Informações do Chamado\" icone=fa-file-text-o> <div ng-if=!$ctrl.chamado.$$state.pending> <div class=chamado-detalhe-mensagem> <strong class=text-info> {{ ::$ctrl.infoChamado.aberturaAssunto | uppercase }} </strong> <hr style=\"margin:10px 0\"> <div class=\"chamado-detalhe simditor simditor-markdown\" md-scroll offset=-170> <div class=simditor-body ng-bind-html=::$ctrl.infoChamado.aberturaMensagem> </div> </div> </div> <div class=chamado-detalhe-status> <span class=text-muted data-placement=top-right data-template-url=template/info-situacao.html data-trigger=hover bs-popover> <icone fa=circle css=\"color={{$ctrl.infoChamado.chamadoSituacao.cor}}\"></icone> {{ $ctrl.infoChamado.chamadoSituacao.nome }} </span> <span class=\"pull-right text-muted\"> {{ $ctrl.infoChamado.categoriaDeServico.nome }} </span> </div> </div> <p ng-if=$ctrl.chamado.$$state.pending class=\"text-muted text-center\" style=\"padding:20px 0\"> <i class=\"fa fa-cog fa-2x fa-spin\"></i> <br/> Aguarde, estamos buscando os dados do Chamado... </p> </painel> <painel titulo=Respostas icone=fa-comments-o subtitulo=\"{{ $ctrl.totalRespostas || '' }}\"> <div ng-if=$ctrl.infoChamado.chamadoAtendimento.iniciadoData> <chat-solicitante respondido=$ctrl.atualizarChamado() chamado=$ctrl.chamado origem=1 permitir-resposta=!$ctrl.infoChamado.bloquear.resposta total=$ctrl.totalRespostas> </chat-solicitante> </div> <div ng-if=!$ctrl.infoChamado.chamadoAtendimento.iniciadoData> <p class=\"text-muted text-center\" style=padding:30px> <i class=\"fa fa-info-circle fa-3x\"></i> <br/><br/> Chamado não iniciado </p> </div> </painel> </div> <div class=col-md-4> <painel titulo=\" Complemento do Chamado\" icone=fa-sitemap> <segmento-selecionado parametros=$ctrl.chamado></segmento-selecionado> </painel> <painel titulo=Classificação icone=fa-sort-amount-asc> <style>.classificacao{padding:10px}.classificacao .btn-group:not(:first-child){border-top:1px solid #ececec;padding-top:10px;margin-top:5px}.classificacao .dropdown-toggle{width:100%;cursor:pointer}.classificacao .class-info{float:left;width:90%}.classificacao .icon{float:right;width:10%}</style> <div class=classificacao style=margin:-15px> <abas> <aba titulo=Atendimento> <div style=\"padding:0 10px 10px 10px;margin-top:-15px\"> <div ng-if=$ctrl.infoChamado.reclassificado> <div class=btn-group style=width:100%> <span class=dropdown-toggle type=button data-toggle=dropdown aria-haspopup=true aria-expanded=false> <span class=class-info> <icone fa=circle css=\"color={{ $ctrl.infoChamado.impacto.cor }}\"></icone> Impacto {{ $ctrl.infoChamado.impacto.nome }} </span> </span> </div> <div class=btn-group style=width:100%> <span class=dropdown-toggle type=button data-toggle=dropdown aria-haspopup=true aria-expanded=false> <span class=class-info> <icone fa=circle css=\"color={{ $ctrl.infoChamado.urgencia.cor }}\"></icone> Urgência {{ $ctrl.infoChamado.urgencia.nome }} </span> </span> </div> <div class=btn-group style=width:100%> <span class=dropdown-toggle type=button data-toggle=dropdown aria-haspopup=true aria-expanded=false> <span class=class-info> <icone fa=circle css=\"color={{ $ctrl.infoChamado.prioridade.cor }}\"></icone> Prioridade {{ $ctrl.infoChamado.prioridade.nome }} </span> </span> </div> </div> <p class=text-muted ng-if=!$ctrl.infoChamado.reclassificado> <i class=\"fa fa-clock-o text-muted\"></i> Aguarde a priorização pelo canal de atendimento com base na análise do seu chamado. </p> </div> </aba> <aba titulo=Solicitado> <div style=\"padding:0 10px 10px 10px;margin-top:-15px\"> <div class=btn-group style=width:100%> <span class=dropdown-toggle type=button data-toggle=dropdown aria-haspopup=true aria-expanded=false> <span class=class-info> <icone fa=circle css=\"color={{ $ctrl.infoChamado.impactoSolicitante.cor }}\"></icone> Impacto {{ $ctrl.infoChamado.impactoSolicitante.nome }} </span> </span> </div> <div class=btn-group style=width:100%> <span class=dropdown-toggle type=button data-toggle=dropdown aria-haspopup=true aria-expanded=false> <span class=class-info> <icone fa=circle css=\"color={{ $ctrl.infoChamado.urgenciaSolicitante.cor }}\"></icone> Urgência {{ $ctrl.infoChamado.urgenciaSolicitante.nome }} </span> </span> </div> <div class=btn-group style=width:100%> <span class=dropdown-toggle type=button data-toggle=dropdown aria-haspopup=true aria-expanded=false> <span class=class-info> <icone fa=circle css=\"color={{ $ctrl.infoChamado.prioridadeSolicitante.cor }}\"></icone> Prioridade {{ $ctrl.infoChamado.prioridadeSolicitante.nome }} </span> </span> </div> </div> </aba> </abas> </div> </painel> <painel titulo=Anexos icone=fa-paperclip subtitulo=\"{{ $ctrl.infoChamado.anexos.length }}\"> <table class=\"table arquivos\" ng-if=\"$ctrl.infoChamado.anexos.length && !$ctrl.infoChamado.$$state.pending\"> <thead> <tr class=text-muted ng-repeat=\"anexo in $ctrl.infoChamado.anexos\"> <td data-placement=left data-container=body data-content=\"{{ ::anexo.arquivoNome }} - {{ ::anexo.arquivoTamanhoEmBytes | dimensaoArquivo }}\" data-trigger=hover bs-popover> <a href=\"\" class=\"btn text-info btn-sm\" ng-if=!anexo.ehImagem baixar-arquivo=anexo style=\"padding:3px 3px\"> <i class=\"fa fa-download\" ng-class=\"{'carregando': anexo.baixando}\"></i> </a> <a href=\"\" class=\"btn text-success btn-sm\" ng-if=anexo.ehImagem visualizar-arquivo=anexo style=\"padding:3px 3px\"> <i class=\"fa fa-photo\" ng-class=\"{'carregando': anexo.abrindo}\"></i> </a> {{ ::anexo.arquivoNome | limitar : 20 }} </td> <td class=\"dimensao text-right\"> <small class=ng-binding> {{ ::anexo.arquivoTamanhoEmBytes | dimensaoArquivo }} </small> </td> </tr> <tr class=\"text-muted total\"> <th class=text-right> <small>Total: </small> </th> <th class=\"dimensao text-right\" style=\"padding:8px 0;white-space:nowrap\"> <small>{{ $ctrl.dimensaoArquivos | dimensaoArquivo }}</small> </th> </tr> </thead> </table> <p ng-if=\"!$ctrl.infoChamado.anexos.length && !$ctrl.infoChamado.$$state.pending\" class=\"text-muted text-center\"> <i class=\"fa fa-info-circle\"></i> Nenhum arquivo anexado </p> <p ng-if=$ctrl.infoChamado.$$state.pending class=\"text-muted text-center\" style=\"padding:20px 0\"> <i class=\"fa fa-cog fa-2x fa-spin\"></i> <br/> Aguarde, estamos buscando os anexos... </p> </painel> </div> </aba> <aba titulo=Redirecionamentos icone=\"fa fa-reply-all\" ng-if=$ctrl.redirecionamentos.length> <painel titulo=Histórico icone=\"fa fa-history\" class=col-sm-12> <div style=\"padding:0 100px\"> <redirecionamentos redirecionamentos=$ctrl.redirecionamentos></redirecionamentos> </div> </painel> </aba> </abas> </div> </div>";

/***/ }),
/* 267 */
/***/ (function(module, exports) {

module.exports = "<div style=text-align:center> Núcleo de Desenvolvimento de Sistemas - Diretoria de Tecnologia da Informação </div> ";

/***/ }),
/* 268 */
/***/ (function(module, exports) {

module.exports = "<nav class=\"navbar navbar-default navbar-fixed-top\"> <div class=\"row container-fluid\"> <div class=\"navbar-header col-sm-3 col-md-2\" style=\"border-right:1px solid #e7e7e7\"> <button type=button class=\"navbar-toggle collapsed\" data-toggle=collapse data-target=#navbar aria-expanded=false aria-controls=navbar> <span class=sr-only>Alterar navegação</span> <span class=icon-bar></span> <span class=icon-bar></span> <span class=icon-bar></span> </button> <a class=navbar-brand href=\"\" ng-click=alternarMenu()> <i class=\"fa fa-phone fa-rotate-20\"></i> <span style=font-size:15px;font-weight:700>Chamados</span> </a> </div> <div id=navbar class=\"navbar-collapse collapse\"> <ul class=\"nav navbar-nav\"> <li ui-active=active> <a href=\"\" ng-click=alternarMenu()> <i class=\"fa text-muted\" ng-class=\"{'fa-navicon': !menu, 'fa-arrow-left': menu }\"></i> </a> </li> </ul> <ul class=\"nav navbar-nav navbar-right\" style=margin-right:10px> <li role=presentation class=dropdown> <a class=dropdown-toggle id=drop6 data-toggle=dropdown role=button aria-haspopup=true aria-expanded=false> <span ng-if=$ctrl.credencial.usuario> <img img-usuario=\"{{ ::$ctrl.credencial.usuario }}\" class=nav-img title=\"{{ ::$ctrl.credencial.usuario }}\"> </span> {{ $ctrl.credencial.usuario || 'Carregando...' }} <span class=caret></span> </a> <ul class=dropdown-menu style=width:600px id=menu3 aria-labelledby=drop6> <li> <credencial-usuario credencial=$ctrl.credencial></credencial-usuario> </li> </ul> </li> <li> <a href=\"\" ng-click=logout()> <i class=\"fa fa-power-off\"></i> Sair </a> </li> </ul> </div> </div> </nav>";

/***/ }),
/* 269 */
/***/ (function(module, exports) {

module.exports = "<div> <ul class=\"nav nav-sidebar nav-sidebar-menu\"> <li expand-menu ui-sref-active=in> <a href=\"\"> <span class=arrow></span> <i class=\"fa fa-inbox\" aria-hidden=true></i> Meus Chamados </a> <ul class=\"nav child-menu\"> <li ui-sref-active=active> <a ui-sref=app.abrir-chamado-segmentos> <i class=\"fa fa-commenting-o\" aria-hidden=true></i> Abrir </a> </li> <li ui-sref-active=active> <a ui-sref=app.meus-chamados> <i class=\"fa fa-paper-plane-o\" aria-hidden=true></i> Abertos </a> </li> </ul> </li> <li expand-menu ui-sref-active=in> <a href=\"\"> <span class=arrow></span> <i class=\"fa fa-book\" aria-hidden=true></i> Manuais </a> <ul class=\"nav child-menu\"> <li ui-sref-active=active> <a href=https://manuais.projecao.br/manual/ccgp/chamados/ target=_blank> <span class=no-arrow></span> <i class=\"fa fa-lightbulb-o\" aria-hidden=true></i> Operacional </a> </li> </ul> </li> </ul> </div> <div class=\"versao-aplicativo text-muted text-center\"> <versao></versao> </div>";

/***/ }),
/* 270 */
/***/ (function(module, exports) {

module.exports = " <div> <layout-header></layout-header> <div class=container-fluid> <div class=row> <div id=sidebar class=\"sidebar sidebar-left col-sm-3 col-md-2 hidden-xs\" style=position:fixed> <layout-sidebar></layout-sidebar> </div> <div class=main ng-class=\"{'col-sm-12 col-md-12': !menuLateral, 'col-sm-9 col-sm-offset-3 col-md-10 col-md-offset-2': menuLateral}\"> <ui-view></ui-view> </div> </div> </div> </div>";

/***/ }),
/* 271 */
/***/ (function(module, exports) {

module.exports = "<table ng-if=$ctrl.chamados.length class=\"table table-hover chamados\"> <tbody> <tr ng-repeat=\"chamado in $ctrl.chamados\"> <td class=chamado> <p> </p><div ng-if=chamado.reclassificado> <span class=text-muted> <icone fa=circle css=\"color={{chamado.impacto.cor}}\"></icone> Impacto {{ chamado.impacto.nome }} </span> <span class=text-muted> <icone fa=circle css=\"color={{chamado.urgencia.cor}}\"></icone> Urgência {{ chamado.urgencia.nome }} </span> <span class=text-muted> <icone fa=circle css=\"color={{chamado.prioridade.cor}}\"></icone> Prioridade {{ chamado.prioridade.nome }} </span> <span class=text-muted> <icone fa=clock-o css=\"color={{chamado.prioridade.cor}}\"></icone> Prazo de atendimento {{ chamado.prioridade.prazo ? chamado.tempoSolucao + ' hora(s)' : 'Planejado' }} </span> </div> <div ng-if=!chamado.reclassificado> <span class=text-muted> <i class=\"fa fa-clock-o\"></i> Aguarde a priorização pelo canal de atendimento com base na análise do seu chamado. </span> </div> <p></p> <p> <strong class=chamado-ticket><i class=\"fa fa-ticket\" aria-hidden=true></i> {{ ::chamado.ticket }}</strong> - <a ui-sref=\"app.detalhe-chamado({chamadoId: chamado.chamadoId})\" style=text-decoration:none> <strong class=text-info title=\"{{ ::chamado.aberturaAssunto }}\">{{ ::chamado.aberturaAssunto | htmlLimpo: 60 }}</strong> </a> <span class=text-muted ng-if=chamado.totalAnexo data-placement=top-right data-content=\"{{ ::chamado.totalAnexo }} arquivo(s) anexado\" data-trigger=hover bs-popover> <i class=\"fa fa-paperclip\"></i> ({{ ::chamado.totalAnexo }}) </span> </p> <p class=text-muted> {{ ::chamado.aberturaMensagem | htmlLimpo: $ctrl.limiteMensagem }} </p> <p class=chamado-fluxo> <span class=\"label label-info\"> <i class=\"fa fa-file-text-o\" aria-hidden=true></i> {{ ::chamado.categoriaDeServico.nome }} </span> <span class=\"label label-success\"> <i class=\"fa fa-support\" aria-hidden=true></i> {{ ::chamado.grupoDeSuporteSegmento.canalDeAtendimento.sigla }} </span> <span class=\"label label-primary\"> <i class=\"fa fa-sitemap\" aria-hidden=true></i> {{ ::chamado.grupoDeSuporteSegmento.nome }} </span> </p> <span class=chamado-monitor> <span class=text-muted> <icone fa=circle css=\"color={{chamado.chamadoSituacao.cor}}\"></icone> {{ chamado.chamadoSituacao.nome }} </span> <span class=text-muted data-placement=top-right data-content=\"Chamado aberto à {{ chamado.aberturaData | tempoDecorrido }} atrás\" data-trigger=hover bs-popover> <i class=\"fa fa-clock-o\" aria-hidden=true></i> {{ chamado.aberturaData | date: 'dd/MM/yyyy HH:mm:ss' }} </span> </span> </td> <td class=nowrap> <a ui-sref=\"app.detalhe-chamado({chamadoId: chamado.chamadoId})\" class=\"btn btn-sm btn-default\"> <i class=\"fa fa-chevron-right text-muted\" style=transform:rotate(-40deg) aria-hidden=true></i> </a> </td> </tr> </tbody> </table>";

/***/ }),
/* 272 */
/***/ (function(module, exports) {

module.exports = "<table ng-if=$ctrl.chamados.length class=\"table table-hover chamados chamado-grade\"> <tbody> <tr ng-repeat=\"chamado in $ctrl.chamados\"> <td class=\"painel col-sm-2\"> <strong class=\"chamado-ticket text-muted\"> <i class=\"fa fa-ticket\" aria-hidden=true></i> {{ ::chamado.ticket }} </strong> <div ng-if=chamado.reclassificado> <span class=text-muted> <icone fa=circle css=\"color={{ chamado.impacto.cor }}\"></icone> Impacto {{ chamado.impacto.nome }} </span> <span class=text-muted> <icone fa=circle css=\"color={{ chamado.urgencia.cor }}\"></icone> Urgência {{ chamado.urgencia.nome }} </span> <span class=text-muted> <icone fa=circle css=\"color={{ chamado.prioridade.cor }}\"></icone> Prioridade {{ chamado.prioridade.nome }} </span> <span class=text-muted> <icone fa=clock-o css=\"color={{ chamado.prioridade.cor }}\"></icone> Prazo de atendimento {{ chamado.prioridade.prazo ? chamado.tempoSolucao + ' hora(s)' : 'Planejado' }} </span> </div> <div ng-if=!chamado.reclassificado> <span class=text-muted> <i class=\"fa fa-clock-o\"></i> Aguarde a priorização pelo canal de atendimento com base na análise do seu chamado. </span> </div> </td> <td class=chamado> <p> <a ui-sref=\"app.detalhe-chamado({chamadoId: chamado.chamadoId})\" style=text-decoration:none> <strong data-placement=top-right data-content=\"{{ ::chamado.aberturaAssunto }}\" data-trigger=hover bs-popover class=text-info> {{ ::chamado.aberturaAssunto | htmlLimpo: 40 }} </strong> </a> <span class=text-muted ng-if=chamado.totalAnexo data-placement=top-right data-content=\"{{ ::chamado.totalAnexo }} arquivo(s) anexado\" data-trigger=hover bs-popover> <i class=\"fa fa-paperclip\"></i> ({{ ::chamado.totalAnexo }}) </span> </p> <p class=text-muted style=margin-bottom:25px> {{ ::chamado.aberturaMensagem | htmlLimpo: 380 }} </p> <p class=chamado-fluxo> <span class=\"label label-info\"> <i class=\"fa fa-file-text-o\" aria-hidden=true></i> {{ ::chamado.categoriaDeServico.nome }} </span> <span class=\"label label-success\"> <i class=\"fa fa-support\" aria-hidden=true></i> {{ ::chamado.grupoDeSuporteSegmento.canalDeAtendimento.sigla }} </span> <span class=\"label label-primary\"> <i class=\"fa fa-sitemap\" aria-hidden=true></i> {{ ::chamado.grupoDeSuporteSegmento.nome }} </span> </p> <span class=chamado-monitor> <span class=text-muted data-placement=top-right data-content=\"{{ chamado.aberturaData | date: 'dd/MM/yyyy HH:mm:ss' }}\" data-trigger=hover bs-popover> {{ chamado.aberturaData | tempoDecorrido }} </span> <span class=text-muted> <icone fa=circle css=\"color={{chamado.chamadoSituacao.cor}}\"></icone> {{ chamado.chamadoSituacao.nome }} </span> </span> </td> <td class=nowrap style=width:70px;text-align:center> <a ui-sref=\"app.detalhe-chamado({chamadoId: chamado.chamadoId})\" class=\"btn btn-sm btn-default\"> <i class=\"fa fa-folder-open-o text-muted\" aria-hidden=true></i> </a> </td> </tr> </tbody> </table> ";

/***/ }),
/* 273 */
/***/ (function(module, exports) {

module.exports = " <hr style=margin:0 /> <div class=\"col-md-5 form-inline\"> <div class=\"form-group pagination\"> <span class=\"btn btn-default\">{{ $ctrl.totalRegistrosEncontrados }} Registro(s)</span> <select class=form-control id=registro-por-pagina name=registro-por-pagina ng-model=$ctrl.maximoRegistrosPorPagina ng-change=$ctrl.atualizarPagina() ng-options=\"total + ' registros por página' for total in [5, 10, 20, 50] track by total\"></select> </div> </div> <div class=col-md-7> <paging class=pull-right page=$ctrl.paginaAtual page-size=$ctrl.maximoRegistrosPorPagina total=$ctrl.totalRegistrosEncontrados paging-action=$ctrl.buscarMeusChamados(page) show-prev-next=true show-first-last=true text-first-class=\"fa fa-angle-double-left\" text-last-class=\"fa fa-angle-double-right\" text-next-class=\"fa fa-angle-right\" text-prev-class=\"fa fa-angle-left\"> </paging> </div> ";

/***/ }),
/* 274 */
/***/ (function(module, exports) {

module.exports = " <div class=col-sm-12> <div class=\"row titulo-pagina\"> <h2> <i class=\"fa fa-paper-plane-o\" aria-hidden=true></i> Abertos <small>({{ $ctrl.totalRegistrosEncontrados }})</small> <span class=\"btn-group pull-right\" title=\"Clique para voltar\" role=group aria-label=...> <a ng-if=history.length onclick=history.back() class=\"btn btn-default text-muted\"> <i class=\"fa fa-arrow-left text-muted\"></i> </a> <a ng-if=\"history.length < 1\" title=\"Clique para avançar\" onclick=history.forward() class=\"btn btn-default text-muted\"> <i class=\"fa fa-arrow-right text-muted\"></i> </a> <a ng-click=$ctrl.atualizar() title=\"Cliquer para atualizar\" class=\"btn btn-default text-muted\"> <i class=\"fa fa-repeat text-muted\"></i> </a> <button type=button class=\"btn btn-default\" title=\"Clique para alternar a forma de exibição\" ng-click=$ctrl.alternarTipoLista()> <i class=\"fa text-muted\" ng-class=\"{'fa-reorder': $ctrl.$storage.tipoListaChamado == 'lista-visao-default', 'fa-th-large': $ctrl.$storage.tipoListaChamado == 'lista-visao-alternativa01'}\"></i> </button> <a ui-sref=app.abrir-chamado-segmentos class=\"btn btn-primary\" style=margin-left:5px> <i class=\"fa fa-commenting-o\"></i> Abrir chamado </a> </span> </h2> </div> <div class=row> <form name=formPesquisaChamado class=form-mix-pesquisa ng-submit=$ctrl.buscarMeusChamados(1)> <div class=\"form-group input-icon col-sm-2 col-md-2\"> <i class=\"fa fa-ticket text-muted\"></i> <input ng-model=$ctrl.pesquisa.ticket placeholder=Ticket class=form-control type=text value=\"\"/> </div> <div class=\"form-group input-icon col-sm-2\"> <i class=\"fa fa-commenting-o text-muted\"></i> <input ng-model=$ctrl.pesquisa.assunto placeholder=Assunto class=form-control type=text value=\"\"/> </div> <div class=\"form-group col-sm-2\"> <select ng-model=$ctrl.pesquisa.canalDeAtendimentoId ng-options=\"canalDeAtendimento.canalDeAtendimentoId as canalDeAtendimento.sigla  for canalDeAtendimento in $ctrl.canaisDeAtendimento track by canalDeAtendimento.canalDeAtendimentoId\" class=form-control> <option value=\"\">Todos os canais</option> </select> </div> <div class=\"form-group col-sm-2\"> <select ng-model=$ctrl.pesquisa.chamadoSituacaoId ng-options=\"situacao.chamadoSituacaoId as situacao.nome for situacao in $ctrl.situacoes track by situacao.chamadoSituacaoId\" class=form-control> <option value=\"\">Todas as situações</option> </select> </div> <div class=\"form-group col-sm-4\"> <div class=input-group> <input ng-model=$ctrl.pesquisa.dataInicio type=text name=dataInicio id=dataInicio class=form-control data-autoclose=true placeholder=dd/mm/aaaa data-max-date=\"{{ $ctrl.pesquisa.dataFim || 'today' }}\" bs-datepicker=\"\" placement=auto> <span class=input-group-addon style=background:#fff>Até</span> <input ng-model=$ctrl.pesquisa.dataFim name=dataFim id=dataFim data-min-date=\"{{ $ctrl.pesquisa.dataInicio }}\" data-max-date=today type=text class=form-control data-autoclose=true placeholder=dd/mm/aaaa bs-datepicker=\"\" placement=auto container=body> <span class=input-group-btn> <button ng-disabled=formPesquisaChamado.$invalid class=\"btn btn-success\" type=submit> <i class=\"fa fa-search\"></i> </button> </span> </div> </div> </form> </div> <div class=row> <div md-scroll offset=-15> <ng-include ng-if=\"$ctrl.$storage.tipoListaChamado == 'lista-visao-default'\" src=\"'meus-chamados/_lista-visao-default.html'\"></ng-include> <ng-include ng-if=\"$ctrl.$storage.tipoListaChamado == 'lista-visao-alternativa01'\" src=\"'meus-chamados/_lista-visao-alternativa01.html'\"></ng-include> <div ng-if=\"!$ctrl.chamados.length && !$ctrl.buscando.$$state.status\"> <hr style=margin-top:0 /> <p class=\"text-muted text-center\" style=\"padding:230px 0\"> <span style=\"margin:0 auto;display:block\"> <i class=\"fa fa-2x fa-cog fa-spin\"></i> </span> Aguarde um momento, estamos buscando os chamados... </p> </div> <div ng-if=\"!$ctrl.chamados.length && $ctrl.buscando.$$state.status\"> <hr style=margin-top:0 /> <p class=\"text-muted text-center\" style=\"padding:230px 0\"> <span style=margin:10px;display:block> <i class=\"fa fa-3x fa-smile-o\"></i> </span> Não encontramos nenhum chamado até o momento. </p> <hr/> </div> </div> <div class=row ng-if=$ctrl.chamados.length ng-include=\"'meus-chamados/_paginacao.html'\"></div> </div> </div>";

/***/ }),
/* 275 */
/***/ (function(module, exports) {

module.exports = "<div class=input-group id=anexar-arquivo> <script type=text/ng-template id=template/colar-imagem.html> <div class=\"popover\" tabindex=\"-1\">\r\n            <div class=\"arrow\"></div>\r\n            <div class=\"popover-content\">\r\n                Pressione <i class=\"btn btn-sm btn-default text-muted\" style=\"font-weight: bold\">PrtScn</i> \r\n                para captura a imagem do monitor, em sequida clique em\r\n                <i class=\"btn btn-sm btn-default text-muted\" style=\"font-weight: bold\">Ctrl</i> +\r\n                <i class=\"btn btn-sm btn-default text-muted\" style=\"font-weight: bold\">v</i>\r\n                para colar a imagem da área de transferência.\r\n            </div>\r\n        </div> </script> <span class=input-group-btn> <label class=\"btn btn-default btn-file\" for=arquivo-anexo> <input multiple=multiple ng-model=$ctrl.arquivo ler-arquivo type=file id=arquivo-anexo name=arquivo-anexo /> <i class=\"fa fa-paperclip text-muted\"></i> </label> </span> <span class=input-group-btn> <button type=button data-placement=bottom-left data-container=body data-template-url=template/colar-imagem.html data-trigger=hover bs-popover class=\"btn btn-default btn-file\"> <i class=\"fa fa-paste text-muted\"></i> </button> </span> <span class=\"form-control anexos\"> <arquivo ng-repeat=\"arquivo in $ctrl.arquivos\" arquivo=arquivo excluir=$ctrl.excluirArquivo(arquivo)></arquivo> </span> <span class=input-text></span> </div>";

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div class=\"\"> <div ng-if=!$ctrl.buscandoMensagens class=qa-message-list id=wallmessages> <div ng-if=\"$ctrl.permitirResposta && ($ctrl.exibirForm || !$ctrl.mensagens.length)\" class=message-item id=m16 ng-paste=$ctrl.colar($event)> <div class=message-inner> <div class=\"message-head clearfix\"> <div class=\"avatar pull-left\"> <img img-usuario=\"{{ ::$ctrl.credencial.usuario }}\"> </div> <div class=user-detail> <h5 class=handle>{{ ::$ctrl.credencial.nome }}</h5> <div class=post-meta> <div class=asker-meta style=margin-top:10px> <anexos arquivos=$ctrl.resposta.anexos dimensao=$ctrl.dimensaoArquivos excluido=$ctrl.arquivoExcluido(arquivo)></anexos> </div> </div> </div> </div> <div class=qa-message-content> <form name=formRespostaChat> <ng-simditor class=simditor-help placeholder=\"Informe sua resposta aqui\" ng-model=$ctrl.resposta.mensagem ng-required=true ng-paste=$ctrl.colar(event) toolbar=\"['bold', 'italic', 'color', '|', 'alignment', '|', 'hr', 'link', '|', 'table', 'markdown']\"> </ng-simditor> </form> <div class=\"message-button row\"> <div class=col-sm-6> <span class=\"text-muted pull-left text-extra\"> <a href=https://guides.github.com/features/mastering-markdown/#what target=_brank> <span class=\"simditor-icon simditor-icon-markdown\"></span> <small>Este editor suporta a sintaxe markdown</small> </a> </span> </div> <div class=\"col-sm-6 text-right\"> <button ng-disabled=formRespostaChat.$invalid ng-click=\"$ctrl.responder( $ctrl.resposta )\" type=button class=\"btn btn-success\"> <i class=\"fa fa-send\"></i> Enviar </button> </div> </div> </div> </div> </div> <p ng-if=\"!$ctrl.mensagens.length && !$ctrl.permitirResposta\" class=\"text-muted text-center\" style=\"padding:40px 0\"> <i class=\"fa fa-comments-o fa-3x text-muted\"></i> <br> <br> O chat ainda não foi iniciado </p> <div ng-repeat=\"mensagem in $ctrl.mensagens\" class=message-item id=m16> <div class=message-inner> <div class=\"message-head clearfix\"> <div class=\"avatar pull-left\"> <img img-usuario=\"{{ ::mensagem.colaborador.usuario }}\"> </div> <div class=user-detail> <h5 class=handle> {{ ::mensagem.colaborador.nome }} <small class=pull-right>{{ ::mensagem.data | tempoDecorrido }} atrás</small> </h5> <div class=post-meta> <div class=asker-meta> <small baixar-arquivo=anexo class=\"file text-muted\" ng-repeat=\"anexo in mensagem.anexos\"> <i class=\"fa fa-paperclip text-muted\"></i> {{ ::anexo.arquivoNome }} </small> <small ng-if=!mensagem.anexos.length class=text-muted>Sem anexos</small> </div> </div> </div> </div> <div class=\"qa-message-content simditor simditor-markdown\"> <div class=simditor-body ng-bind-html=mensagem.mensagem></div> </div> </div> <div class=status-inner> <span class=text-muted> <icone fa=circle css=\"color={{ ::mensagem.situacao.cor }}\"></icone> {{ ::mensagem.situacao.nome }} </span> <button ng-click=\"$ctrl.exibirForm = true\" ng-if=\"$index == 0 && $ctrl.permitirResposta && !$ctrl.exibirForm\" style=margin-top:-5px class=\"pull-right btn btn-success btn-sm\"> <i class=\"fa fa-reply\"></i> Responder </button> </div> </div> </div> <p ng-if=$ctrl.buscandoMensagens class=\"text-muted text-center\" style=\"padding:10px 20px\"> <img src=" + __webpack_require__(132) + " alt=\"\"> <br> Aguarde um momento, estamos buscando as mensagens... </p> </div>";

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div class=\"\"> <div ng-if=!$ctrl.buscandoMensagens class=qa-message-list id=wallmessages> <div ng-if=\"$ctrl.permitirResposta && $ctrl.exibirForm\" class=message-item id=m16 ng-paste=$ctrl.colar($event)> <div class=message-inner> <div class=\"message-head clearfix\"> <div class=\"avatar pull-left\"> <img img-usuario=\"{{ ::$ctrl.credencial.usuario }}\"> </div> <div class=user-detail> <h5 class=handle>{{ ::$ctrl.credencial.nome }}</h5> <div class=post-meta> <div class=asker-meta style=margin-top:10px> <anexos arquivos=$ctrl.resposta.anexos dimensao=$ctrl.dimensaoArquivos excluido=$ctrl.arquivoExcluido(arquivo)></anexos> </div> </div> </div> </div> <div class=qa-message-content> <form name=formRespostaChat> <ng-simditor class=simditor-help placeholder=\"Informe sua resposta aqui\" ng-model=$ctrl.resposta.mensagem ng-required=true ng-paste=$ctrl.colar(event) toolbar=\"['bold', 'italic', 'color', '|', 'alignment', '|', 'hr', 'link', '|', 'table', 'markdown']\"> </ng-simditor> <div class=\"message-button row\"> <div class=col-sm-6> <lista-situacoes name=situacao id=situacao ng-model=$ctrl.resposta.situacao ng-required=true> </lista-situacoes> </div> <div class=\"col-sm-6 text-right\"> <button ng-disabled=formRespostaChat.$invalid ng-click=\"$ctrl.responder( $ctrl.resposta )\" type=button class=\"btn btn-success\"> <i class=\"fa fa-send\"></i> Enviar </button> </div> </div> </form> </div> </div> </div> <div ng-repeat=\"mensagem in $ctrl.mensagens\" class=message-item id=m16> <div class=message-inner> <div class=\"message-head clearfix\"> <div class=\"avatar pull-left\"> <img img-usuario=\"{{ ::mensagem.colaborador.usuario }}\"> </div> <div class=user-detail> <h5 class=handle> {{ ::mensagem.colaborador.nome }} <small class=pull-right>{{ ::mensagem.data | tempoDecorrido }} atrás</small> </h5> <div class=post-meta> <div class=asker-meta> <small baixar-arquivo=anexo class=\"file text-muted\" ng-repeat=\"anexo in mensagem.anexos\"> <i class=\"fa fa-paperclip text-muted\"></i> {{ ::anexo.arquivoNome }} </small> <small ng-if=!mensagem.anexos.length class=text-muted>Sem anexos</small> </div> </div> </div> </div> <div class=\"qa-message-content simditor simditor-markdown\"> <div class=simditor-body ng-bind-html=mensagem.mensagem></div> </div> </div> <div class=status-inner> <span class=text-muted> <icone fa=circle css=\"color={{ ::mensagem.situacao.cor }}\"></icone> {{ ::mensagem.situacao.nome }} </span> <button ng-click=\"$ctrl.exibirForm = true\" ng-if=\"$index == 0 && $ctrl.permitirResposta && !$ctrl.exibirForm\" style=margin-top:-5px class=\"pull-right btn btn-success btn-sm\"> <i class=\"fa fa-reply\"></i> Responder </button> </div> </div> <p ng-if=!$ctrl.mensagens.length class=\"text-muted text-center\" style=\"padding:40px 0\"> <i class=\"fa fa-comments-o fa-3x text-muted\"></i> <br> <br> Não há mensagens para exibir </p> </div> <p ng-if=$ctrl.buscandoMensagens class=\"text-muted text-center\" style=\"padding:10px 20px\"> <img src=" + __webpack_require__(132) + " alt=\"\"> <br> Aguarde um momento, estamos buscando as mensagens... </p> </div>";

/***/ }),
/* 278 */
/***/ (function(module, exports) {

module.exports = "<div class=\"col-md-12 col-sm-12 col-xs-12\" style=\"padding:0 10px 15px 10px\"> <div class=x_panel ng-if=$ctrl.credencial.usuario> <div class=\"x_content box-profile\"> <div class=\"row col-md-6 col-sm-6 col-xs-12\"> <div class=\"col-md-12 col-sm-12 col-xs-12\"> <img class=avatar-view img-usuario=\"{{ $ctrl.credencial.usuario }}\" style=width:230px alt=Foto title=\"Minha Foto\"> </div> <div class=\"col-md-12 col-sm-12 col-xs-12\"> <div class=profile_title> <h5 class=text-muted>{{ $ctrl.credencial.nome || 'Nome não informado' }}</h5> <small class=text-muted>{{ $ctrl.credencial.registroAd.cargo }}</small> </div> <hr/> <p class=text-muted> <i class=\"fa fa-exclamation-circle\"></i> Os seus dados são buscados no AD Corporativo, caso os mesmos estejam desatualizados, por gentileza, solicite a correção <a href=\"mailto:ServiceDesk@projecao.br?Subject=Atualização de dados pessoais\" target=_top>clicando aqui</a>. </p> </div> </div> <div class=\"col-md-6 col-sm-6 col-xs-12\"> <strong class=text-muted> <i class=\"fa fa-user-o\"></i> Usuário: </strong> <br> <span>{{ $ctrl.credencial.usuario || 'Usuário não informado' }}</span> <hr style=\"margin:10px 0\"> <strong class=text-muted> <i class=\"fa fa-phone\"></i> Telefones: </strong> <br> <span> {{ $ctrl.credencial.telefone || 'O telefone não foi informado' }} </span> <hr style=\"margin:10px 0\"> <strong class=text-muted> <i class=\"fa fa-envelope-o\"></i> E-mail corporativo: </strong> <br> <span>{{ $ctrl.credencial.emailCorporativo || 'O e-mail corporativo não foi criado' }}</span> <hr style=\"margin:10px 0\"> <strong class=text-muted> <i class=\"fa fa-envelope-o\"></i> E-mail pessoal: </strong> <br> <span>{{ $ctrl.credencial.emailPessoal || 'O e-mail pessoal não foi informado' }}</span> <hr style=\"margin:10px 0\"> <strong class=text-muted> <i class=\"fa fa-group\"></i> Departamento: </strong> <br> <span>{{ $ctrl.credencial.registroAd.departamento || 'O departamento não foi informado' }}</span> <hr style=\"margin:10px 0\"> <strong class=text-muted> <i class=\"fa fa-registered\"></i> Empresa: </strong> <br> <span>{{ $ctrl.credencial.registroAd.empresa || 'A empresa não foi informada' }}</span> <hr style=\"margin:10px 0\"> <strong class=text-muted> <i class=\"fa fa-building-o\"></i> Unidade: </strong> <br> <span>{{ $ctrl.credencial.registroAd.unidade || 'A unidade não foi informada' }}</span> </div> </div> </div> <p class=\"text-muted text-center\" ng-if=!$ctrl.credencial.usuario style=\"padding:30px 0\"> <i class=\"fa fa-cog fa-spin fa-2x fa-fw\"></i><br/> Buscando dados, aguarde... <span class=sr-only>Buscando dados, aguarde...</span> </p> </div> ";

/***/ }),
/* 279 */
/***/ (function(module, exports) {

module.exports = "<div class=btn-group style=width:100%> <span class=\"btn btn-default dropdown-toggle\" type=button data-toggle=dropdown aria-haspopup=true aria-expanded=false> <span class=class-info> <icone fa=circle css=\"color={{ $ctrl.situacao.cor || '#969696' }}\"></icone> {{ $ctrl.situacao.nome || 'Selecionae uma Situação' }} </span> <span class=icon> <i class=\"fa fa-sort-desc\" aria-hidden=true></i> </span> </span> <ul class=dropdown-menu> <li class=dropdown-header>Qual a situação do chamado neste momento?</li> <li role=separator class=divider></li> <li ng-repeat=\"situacao in $ctrl.situacoes\" ng-click=\"$ctrl.selecionarSituacao( situacao )\"> <a href=\"\"> <icone fa=circle css=\"color={{ situacao.cor }}\"></icone> {{ situacao.nome }} </a> </li> </ul> </div>";

/***/ }),
/* 280 */
/***/ (function(module, exports) {

module.exports = "<div class=\"panel panel-default\" ng-class=$ctrl.class> <div class=panel-heading ng-if=$ctrl.titulo> <i class=\"fa {{ $ctrl.icone || 'fa-list-alt' }} text-muted\"></i> {{ $ctrl.titulo }} <span class=pull-right style=color:#aeaeae>{{ $ctrl.subtitulo }}</span> </div> <div class=panel-body ng-transclude></div> </div>";

/***/ }),
/* 281 */
/***/ (function(module, exports) {

module.exports = "<div class=\"timeline timeline-single-column\"> <div ng-repeat=\"redirecionamento in $ctrl.redirecionamentos\"> <div class=timeline-item> <div class=timeline-point> <i class=fa ng-class=\"{ 'fa-share': $ctrl.de, 'fa-check': !$ctrl.de }\"></i> </div> <div class=timeline-event> <div class=timeline-heading> <h5 class=timeline-heading-title> <span>De</span> {{ redirecionamento.canalDe.sigla }} <br> <span>Para</span> {{ redirecionamento.canalPara.sigla }} <small class=\"text-muted pull-right\"> {{ redirecionamento.data | tempoDecorrido }} atrás </small> </h5> </div> <div class=timeline-body> <p class=text-muted>{{ redirecionamento.motivo.nome || 'Último redirecionamento' }}</p> </div> <div class=\"timeline-footer text-muted\"> <p class=text-right ng-if=redirecionamento.usuarioRedirecionamento> por {{ redirecionamento.usuarioRedirecionamento }} </p> </div> </div> </div> </div> </div>";

/***/ }),
/* 282 */
/***/ (function(module, exports) {

module.exports = "<div> <div ng-if=$ctrl.exibir.segmento> <div class=col-sm-12> <strong class=text-muted> Grupo de Suporte: </strong> <br> <span> {{ ::$ctrl.exibir.segmento.grupoDeSuporte.nome }} </span> <hr style=\"margin:10px 0\"> </div> <br/> <div class=col-sm-12> <strong class=text-muted> Canal de Atendimento: </strong> <br> <span> {{ ::$ctrl.exibir.segmento.canalDeAtendimento.nome }} </span> <hr style=\"margin:10px 0\"> </div> <br/> <div class=col-sm-12> <strong class=text-muted> Serviço Solicitado: </strong><br> <span> {{ ::$ctrl.exibir.segmento.grupoDeSuporteSegmento.nome }} </span> </div> </div> <p class=\"text-muted text-center\" ng-if=!$ctrl.exibir.segmento style=\"padding:30px 0\"> <i class=\"fa fa-cog fa-spin fa-2x fa-fw\"></i><br/> Buscando dados, aguarde... <span class=sr-only>Buscando dados, aguarde...</span> </p> </div>";

/***/ }),
/* 283 */
/***/ (function(module, exports) {

module.exports = "<div class=modal tabindex=-1 role=dialog aria-hidden=true> <div class=\"modal-dialog modal-lg\" style=width:90%;height:100%> <div class=modal-content style=width:100%;height:90%;position:relative> <div class=\"modal-header text-muted\" ng-show=title> <button type=button class=close aria-label=Close ng-click=$hide()> <i class=\"fa fa-close\"></i> </button> <h4 class=modal-title> {{ ::title }} <button class=\"btn btn-default btn-sm btn-success\" baixar-arquivo=arquivo> <i class=\"fa fa-download\"></i> Baixar imagem </button> </h4> </div> <div class=modal-body style=height:92%> <preview-image src=content></preview-image> </div> </div> </div> </div> ";

/***/ }),
/* 284 */,
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 17,
	"./af.js": 17,
	"./ar": 24,
	"./ar-dz": 18,
	"./ar-dz.js": 18,
	"./ar-kw": 19,
	"./ar-kw.js": 19,
	"./ar-ly": 20,
	"./ar-ly.js": 20,
	"./ar-ma": 21,
	"./ar-ma.js": 21,
	"./ar-sa": 22,
	"./ar-sa.js": 22,
	"./ar-tn": 23,
	"./ar-tn.js": 23,
	"./ar.js": 24,
	"./az": 25,
	"./az.js": 25,
	"./be": 26,
	"./be.js": 26,
	"./bg": 27,
	"./bg.js": 27,
	"./bn": 28,
	"./bn.js": 28,
	"./bo": 29,
	"./bo.js": 29,
	"./br": 30,
	"./br.js": 30,
	"./bs": 31,
	"./bs.js": 31,
	"./ca": 32,
	"./ca.js": 32,
	"./cs": 33,
	"./cs.js": 33,
	"./cv": 34,
	"./cv.js": 34,
	"./cy": 35,
	"./cy.js": 35,
	"./da": 36,
	"./da.js": 36,
	"./de": 39,
	"./de-at": 37,
	"./de-at.js": 37,
	"./de-ch": 38,
	"./de-ch.js": 38,
	"./de.js": 39,
	"./dv": 40,
	"./dv.js": 40,
	"./el": 41,
	"./el.js": 41,
	"./en-au": 42,
	"./en-au.js": 42,
	"./en-ca": 43,
	"./en-ca.js": 43,
	"./en-gb": 44,
	"./en-gb.js": 44,
	"./en-ie": 45,
	"./en-ie.js": 45,
	"./en-nz": 46,
	"./en-nz.js": 46,
	"./eo": 47,
	"./eo.js": 47,
	"./es": 49,
	"./es-do": 48,
	"./es-do.js": 48,
	"./es.js": 49,
	"./et": 50,
	"./et.js": 50,
	"./eu": 51,
	"./eu.js": 51,
	"./fa": 52,
	"./fa.js": 52,
	"./fi": 53,
	"./fi.js": 53,
	"./fo": 54,
	"./fo.js": 54,
	"./fr": 57,
	"./fr-ca": 55,
	"./fr-ca.js": 55,
	"./fr-ch": 56,
	"./fr-ch.js": 56,
	"./fr.js": 57,
	"./fy": 58,
	"./fy.js": 58,
	"./gd": 59,
	"./gd.js": 59,
	"./gl": 60,
	"./gl.js": 60,
	"./gom-latn": 61,
	"./gom-latn.js": 61,
	"./he": 62,
	"./he.js": 62,
	"./hi": 63,
	"./hi.js": 63,
	"./hr": 64,
	"./hr.js": 64,
	"./hu": 65,
	"./hu.js": 65,
	"./hy-am": 66,
	"./hy-am.js": 66,
	"./id": 67,
	"./id.js": 67,
	"./is": 68,
	"./is.js": 68,
	"./it": 69,
	"./it.js": 69,
	"./ja": 70,
	"./ja.js": 70,
	"./jv": 71,
	"./jv.js": 71,
	"./ka": 72,
	"./ka.js": 72,
	"./kk": 73,
	"./kk.js": 73,
	"./km": 74,
	"./km.js": 74,
	"./kn": 75,
	"./kn.js": 75,
	"./ko": 76,
	"./ko.js": 76,
	"./ky": 77,
	"./ky.js": 77,
	"./lb": 78,
	"./lb.js": 78,
	"./lo": 79,
	"./lo.js": 79,
	"./lt": 80,
	"./lt.js": 80,
	"./lv": 81,
	"./lv.js": 81,
	"./me": 82,
	"./me.js": 82,
	"./mi": 83,
	"./mi.js": 83,
	"./mk": 84,
	"./mk.js": 84,
	"./ml": 85,
	"./ml.js": 85,
	"./mr": 86,
	"./mr.js": 86,
	"./ms": 88,
	"./ms-my": 87,
	"./ms-my.js": 87,
	"./ms.js": 88,
	"./my": 89,
	"./my.js": 89,
	"./nb": 90,
	"./nb.js": 90,
	"./ne": 91,
	"./ne.js": 91,
	"./nl": 93,
	"./nl-be": 92,
	"./nl-be.js": 92,
	"./nl.js": 93,
	"./nn": 94,
	"./nn.js": 94,
	"./pa-in": 95,
	"./pa-in.js": 95,
	"./pl": 96,
	"./pl.js": 96,
	"./pt": 98,
	"./pt-br": 97,
	"./pt-br.js": 97,
	"./pt.js": 98,
	"./ro": 99,
	"./ro.js": 99,
	"./ru": 100,
	"./ru.js": 100,
	"./sd": 101,
	"./sd.js": 101,
	"./se": 102,
	"./se.js": 102,
	"./si": 103,
	"./si.js": 103,
	"./sk": 104,
	"./sk.js": 104,
	"./sl": 105,
	"./sl.js": 105,
	"./sq": 106,
	"./sq.js": 106,
	"./sr": 108,
	"./sr-cyrl": 107,
	"./sr-cyrl.js": 107,
	"./sr.js": 108,
	"./ss": 109,
	"./ss.js": 109,
	"./sv": 110,
	"./sv.js": 110,
	"./sw": 111,
	"./sw.js": 111,
	"./ta": 112,
	"./ta.js": 112,
	"./te": 113,
	"./te.js": 113,
	"./tet": 114,
	"./tet.js": 114,
	"./th": 115,
	"./th.js": 115,
	"./tl-ph": 116,
	"./tl-ph.js": 116,
	"./tlh": 117,
	"./tlh.js": 117,
	"./tr": 118,
	"./tr.js": 118,
	"./tzl": 119,
	"./tzl.js": 119,
	"./tzm": 121,
	"./tzm-latn": 120,
	"./tzm-latn.js": 120,
	"./tzm.js": 121,
	"./uk": 122,
	"./uk.js": 122,
	"./ur": 123,
	"./ur.js": 123,
	"./uz": 125,
	"./uz-latn": 124,
	"./uz-latn.js": 124,
	"./uz.js": 125,
	"./vi": 126,
	"./vi.js": 126,
	"./x-pseudo": 127,
	"./x-pseudo.js": 127,
	"./yo": 128,
	"./yo.js": 128,
	"./zh-cn": 129,
	"./zh-cn.js": 129,
	"./zh-hk": 130,
	"./zh-hk.js": 130,
	"./zh-tw": 131,
	"./zh-tw.js": 131
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 285;

/***/ }),
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */
/***/ (function(module, exports) {

module.exports = {
	"production": {
		"UrlApi": "https://app.projecao.br/ccgp/api",
		"UrlBase": "https://app.projecao.br/ccgp"
	},
	"development": {
		"UrlApi": "https://localhost:44341/ccgp/api",
		"UrlBase": "https://localhost:44341/ccgp"
	},
	"homologation": {
		"UrlApi": "https://app.projecao.br/ccgp_homologacao/api",
		"UrlBase": "https://app.projecao.br/ccgp_homologacao"
	},
	"training": {
		"UrlApi": "https://app.projecao.br/ccgp_treinamento/api",
		"UrlBase": "https://app.projecao.br/ccgp_treinamento"
	}
};

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
﻿/**
 * @ngDoc Component
 * @name ng.component:aba
 *
 * @description
 *
 * O componete nos permite o uso de abas
 * de forma simples e pratica.
 *
 * @example
 *
 * <abas>
 *      <aba titulo="A">
 *          // corpo A
 *      </aba>
 *      <aba titlulo="B">
 *          // corpo B
 *      </aba>
 * </abas>
 *
 * @element E
 * @require lodash
 *
 */


var centralApp = angular.module('app.components');

centralApp.component('abas', {
        transclude: true,
        bindings: {
            selecionada: '=?'
        },
        controllerAs: '$ctrl',
        controller: AbasController,
        template: [
            '<div class="" role="tabpanel" data-example-id="togglable-tabs">',
                '<ul id="myTab" class="nav nav-tabs " role="tablist">',
                    '<li ng-repeat="aba in $ctrl.abas" ng-click="$ctrl.selecionar(aba)" ng-class="{active:aba.selecionado}" ',
                        'role="presentation" calss="{{ ::aba.class || \'\' }}">',
                        '<a href="" id="home-tab" role="tab" data-toggle="tab" aria-expanded="true">',
                            '<i ng-if="aba.icone" class="{{ ::aba.icone || \'\'}} text-muted" aria-hidden="true"></i> ',
                            '{{ ::aba.titulo }}',
                        '</a>',
                    '</li>',
                '</ul>',
                '<div id="TapContent" ng-transclude class="tab-content" style="margin-top: 30px"></div>',
            '</div>'
        ].join('')
    })
    .component('aba', {
        transclude: true,
        require: {
            abas: '^abas'
        },
        bindings: {
            titulo: '@',
            icone: '@?',
            class: '@?'
        },
        controllerAs: '$ctrl',
        controller: function () {
            this.$onInit = function () {
                this.abas.adicionar(this);
            };
        },
        template: [
            '<div role="tabpanel" class="tab-pane" ng-show="$ctrl.selecionado" ng-transclude aria-labelledby="profile-tab">',
            '</div>'
        ].join('')
    });

AbasController.$inject = ['Event'];
function AbasController(Event) {

    var $ctrl = this;

    $ctrl.abas = [];

    // Adicionar aba
    $ctrl.adicionar = function (aba) {
        if ($ctrl.abas.length == 0) {
            aba.selecionado = true;
        }
        $ctrl.abas.push(aba);

        Event.on('aba:' + aba.titulo, function () {
            $ctrl.selecionar(aba)
        })
    };

    // Seleciona aba
    $ctrl.selecionar = function (aba) {
        _.map($ctrl.abas, function (aba) {
            aba.selecionado = false;
        });

        $ctrl.selecionada = aba.titulo

        aba.selecionado = true;
    };

}


/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__anexos_css__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__anexos_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__anexos_css__);
﻿



var centralApp = angular.module('app.components');

centralApp.component('anexos', {
    bindings: {
        arquivos: '=',
        dimensao: '=?',
        excluido: '&?'
    },
    controllerAs: '$ctrl',
    controller: anexosCtrl,
    template: __webpack_require__(275)
});

centralApp.component('arquivo', {
    require: {
        anexos: '^?anexos'
    },
    bindings: {
        arquivo: '<',
        excluir: '&'
    },
    controllerAs: '$ctrl',
    controller: arquivoAnexoCtrl,
    template: [
        '<span class="label label-primary pull-left anexo" title="{{ ::$ctrl.arquivo.name }}">',
            '{{ ::$ctrl.arquivo.name | htmlLimpo: 30 }} ',
            '<a href="" ng-click="$ctrl.excluirArquivo()" style="color: #fff">x</a>',
        '</span>'
    ].join('')
});

anexosCtrl.$inject = ['$scope', '$timeout', 'Event'];
function anexosCtrl($scope, $timeout, Event)
{
    var $ctrl = this;

    $ctrl.arquivo = null;

    $ctrl.colarArquivo = colarArquivo;
    $ctrl.adicionarTransferido = adicionarTransferido;
    $ctrl.adicionarAnexo = adicionarAnexo;
    $ctrl.ehImagem = ehImagem;

    // Começamos verificando se o navegador suporta o 
    // objeto Clipboard. Se não, precisamos criar um 
    // elemento contenteditable que captura todos os 
    // dados colados
    if (false /*!window.Clipboard */) {
        var pasteCatcher = document.createElement("div");
            
        // Firefox permite que imagens sejam coladas em 
        // elementos contenteditable
        pasteCatcher.setAttribute("contenteditable", "");
            
        // Podemos esconder o elemento e anexá-lo ao body
        pasteCatcher.style.opacity = 0;
        document.body.appendChild(pasteCatcher);
        
        // Nós certifique-se que está sempre no foco
        pasteCatcher.focus();
        document.addEventListener("click", function() { 
            pasteCatcher.focus(); 
        });

        // Adicinoa o outvinte de eventos colar
        window.addEventListener("paste", $ctrl.colarArquivo);
    } 


    /**
     * Executado após o componetes estar pronto
     * para renderização.
     */
    $ctrl.$onInit = function(){
        $ctrl.dimensao = $ctrl.dimensao || 0;
        $ctrl.arquivos = $ctrl.arquivos || [];
    }

    /**
     * Calcula a dimensao totao dos arquivos
     * adicionado como anexo.
     */
    $scope.calcularDimensaoArquivo = function () {
        $ctrl.dimensao = _.sumBy($ctrl.arquivos, 'size');
    };

    // Calcula dimensão total dos arquivos
    $scope.calcularDimensaoArquivo();

    /**
     * Exclui arquivo da lista de anexos
     * 
     * @param object arquivo
     */
    $ctrl.excluirArquivo = function (arquivo) {
        
        var index = $ctrl.arquivos.indexOf(arquivo);
        $ctrl.arquivos.splice(index, 1);

        if ($ctrl.excluido) {
            $ctrl.excluido({
                arquivo: arquivo
            });
        }

    };

    // Vamos observar mudanças no arquivo para 
    // adiciona-los a lista
    $scope.$watch('$ctrl.arquivo', function (arquivos) {

        if (arquivos) {
            if (arquivos.length > 1) {
                _.each(arquivos, function (arquivo) {
                    $ctrl.adicionarAnexo(arquivo);
                })
            } else {
                $ctrl.adicionarAnexo(_.first(arquivos));
            }
        }

        $scope.calcularDimensaoArquivo();
    });

    /**
     * Adiciona o arquivo a lista de anexos
     * 
     * @param File arquivo
     */
    function adicionarAnexo(arquivo) {
        arquivo.ehImagem = $ctrl.ehImagem(arquivo.type);

        $ctrl.arquivos.push(arquivo);
    }

    /**
     * Permite a adição de arquivos no campo anexo.
     * Mas para está função funcionar é necessário o 
     * uso do evento paste.
     * 
     * @param object event
     * @param handler callback
     */
    function colarArquivo(event, callback) {

        var items = (
            _.get(event, 'clipboardData', null) || 
            _.get(event, 'originalEvent.clipboardData', {})
        ).items || [];

        var files = [].slice.call(items)

        files.forEach(function (file) {
            if($ctrl.ehImagem(file.type)) {
                $ctrl.adicionarTransferido(
                    file.getAsFile(),  callback
                );
            }
        })

    }

    function ehImagem (tipo) {
        return /png|jpg|jpeg|gif/g.test(tipo);
    }

    /**
     * Adiciona na lista de anexos o arquivo 
     * obtido da área de transferência.
     * 
     * @param Blob arquivo
     * @param handler callback
     */
    function adicionarTransferido(arquivo, callback) {

        if (arquivo) {

            // O arquivo obtido da área de transf~encia
            // não tem nome, então vamos criar um alternativo.
            var nomeArquivo = [
                'imagem-capturada-',
                moment().format('DDMMYYYYHHmmss'),
                _.last(arquivo.type.split('/'))
            ].join('.');

            // Criamos o arquivo
            var arquivoTransferido = new File([arquivo], nomeArquivo, { type: arquivo.type, lastModified: moment() });

            // Adicionamos o arquivo da área de transferência
            // na lista de arquivos em anexo.
            $ctrl.adicionarAnexo(arquivoTransferido);

            $scope.calcularDimensaoArquivo();

            // Executamos uma função de callback
            (callback || _.noop)(arquivoTransferido);
        }

    }

    /**
     * Este ouvinte nos possibilita ter um recurso adicional que
     * permir o usuário enviar arquivos para o campo de anexo
     * de qualquer lugar da página com o envento paste do angular.
     * 
     * @param object event
     * @param object originalEvent
     */
    Event.on('anexo.colar-arquivo', function (event, originalEvent, handle) {
        
        if (originalEvent) {

            $ctrl.colarArquivo(originalEvent, function (arquivo) {

                $timeout(function () {
                    ( handle || _.noop )(arquivo);
                    
                    $scope.$apply();
                }, 100);

            });
        }

    });
}

arquivoAnexoCtrl.$inject = ['$scope'];

/**
 * Exclui o arquivo da lista
 */
function arquivoAnexoCtrl($scope)
{
    var $ctrl = this;

    $ctrl.excluirArquivo = function () {
        $ctrl.excluir($ctrl.arquivo);
    }
}


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
﻿/**
 * Move um elemento sobre a tela
 *
 * Como usar:
 * 1) Adicione o attibuto arrastar no elemente que deseja mover.
 * <div arrastavel>Meu elemento arrastável</div>
 *
 * 2) Adicione o styale com a propriedade cursor igual move para
 *    definir o ponto responsável por arrastar o elemento.
 *
 *  <div arrastavel>
 *      <h1 style="cursor: move">Clique aqui para arrastar</h1>
 *      <p>Meu elemento arrastável</p>
 *  </div>
 */



var balcaoApp = angular.module('app.components');

balcaoApp.directive('arrastavel', arrastarDirective);

arrastarDirective.$inject = ['$document'];
function arrastarDirective($document) {

    return {
        restrict: 'A',
        link: function (scope, element, attr) {
            var startX = 0, startY = 0, x = 0, y = 0;

            element.css({
                position: 'relative',
                backgroundColor: '#fff'
            });

            element.on('dblclick', function (event) {
                if (mover(event)) {
                    event.preventDefault();
                    startX = 0; startY = 0; x = 0; y = 0;
                    element.css({
                        top: y + 'px',
                        left: x + 'px'
                    });
                }
            });

            element.on('mousedown', function (event) {

                if (mover(event)) {
                    startX = event.pageX - x;
                    startY = event.pageY - y;
                    $document.on('mousemove', mousemove);
                    $document.on('mouseup', mouseup);
                }

                return;

            });

            function mousemove(event) {
                y = event.pageY - startY;
                x = event.pageX - startX;

                element.css({
                    top: y + 'px',
                    left: x + 'px',
                }).addClass('effect6');
            }

            function mouseup() {
                $document.off('mousemove', mousemove);
                $document.off('mouseup', mouseup);
            }

            function mover(event) {
                return (event.target.style.cursor == 'move');
            }
        }
    };

}


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
﻿

var centralApp = angular.module('app.components');

centralApp.directive('baixarArquivo', function () {

    return {
        restrict: 'A',
        scope: {
            // objeto contendo chamadoId e anexoId
            arquivo: '=baixarArquivo'
        },
        controllerAs: '$ctrl',
        controller: baixarAnexoCtrl,
        link: function ($scope, $element, $attr) {

            $element.bind('click', function (e) {
                e.preventDefault();

                $scope.baixar();
            });

        }
    }

});

baixarAnexoCtrl.$inject = ['$scope', 'notificacao', 'anexoApi'];

function baixarAnexoCtrl($scope, notificacao, anexoApi)
{
    $scope.baixar = function () {
        $scope.arquivo.baixando = true;
        anexoApi.baixarArquivo( $scope.arquivo , function (resposta) {
            saveAs(new File([resposta.data], $scope.arquivo.arquivoNome, {
                type: resposta.headers['content-type']
            }));
            $scope.arquivo.baixando = false;
        }, function(error) {
            notificacao.erro('Houve um erro ao baixar o arquivo');
            $scope.arquivo.baixando = false;
        });

    }
}

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
﻿/**
 * Componente para alternar opcao
 * 
 * Exemplo: 
 * <bto-alternar alvo="$ctrl.ativo" />
 */




var centralApp = angular.module('app.components');


centralApp.component('btoAlternar', {
    controllerAs: '$ctrl',
    bindings: {
        alvo: '=',
        cache: '=?',
        manipulador: '&?'
    },
    transclude: true,
    controller: btoAlternarCtrl,
    template: [
        '<span class="text-muted pull-right">',
            '<i ng-click="$ctrl.alternar()" style="cursor: pointer;" class="fa" ng-class="{\'fa-toggle-on text-success\': $ctrl.alvo,\'fa-toggle-off\': !$ctrl.alvo}"></i> ',
            '<small ng-transclude></small>',
        '</span>'
    ].join('')
});

btoAlternarCtrl.$inject = ['$localStorage'];
function btoAlternarCtrl($localStorage) {
    var $ctrl = this;

    $ctrl.alternar = function () {

        $ctrl.alvo = !$ctrl.alvo;

        ($ctrl.manipulador || _.noop)({
            alvo: $ctrl.alvo
        });

    }
}


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

angular.module('app.components').component('chatAtendente', {
    bindings: {
        chamado: '=',
        origem: '=',
        total: '=?',
        permitirResposta: '=',
        respondido: '&?'
    },
    controller: discussaoCtrl,
    template: __webpack_require__(276)
});

discussaoCtrl.$inject = ['$scope', 'Chat', 'notificacao', 'Event', 'Usuario', 'categorizacoesApi']

function discussaoCtrl ($scope, Chat, notificacao, Event, Usuario, categorizacoesApi) 
{
    var $ctrl = this;

    $ctrl.mensagens = [];  
    $ctrl.resposta = {  anexos: [] };
    $ctrl.buscarMensagens = buscarMensagens;
    $ctrl.responder = responder;
    $ctrl.colar = colar;
    $ctrl.chamadoId = null;
    $ctrl.credencial = {};
    $ctrl.situacoes = [];
    $ctrl.buscandoMensagens = true;
    $ctrl.atualizar = true;
    $ctrl.exibirForm = false;

    Event.on('chat:atualizar', function(event, payload){
        if( payload.chamadoId && $ctrl.chamadoId == $ctrl.chamadoId  && $ctrl.atualizar){
            $ctrl.buscarMensagens( $ctrl.chamadoId ).then(function(){
                $ctrl.respondido()
            });
        }

        $ctrl.atualizar = true;
    })($scope)

    /**
     * Obtém a credencial do usuário logado
     */
    Usuario.credencial().then(function ( perfil ) {
        $ctrl.credencial = perfil.data.credencial;
    });

    $ctrl.$onInit = function()
    {
        $ctrl.chamado.then(function(chamado){
            $ctrl.chamadoId = chamado.chamadoId;

            // Indica que as mensagens estão sendo buscadas
            $ctrl.buscandoMensagens = true;

            $ctrl.buscarMensagens( chamado.chamadoId )
        });

        $ctrl.origem = $ctrl.origem || 0;

        // Indica a quantidade de mensagens
        $ctrl.total = $ctrl.total || 0;
    }

    /**
     * Busca as mensagens do chamado
     * 
     * @param {string} chamadoId 
     */
    function buscarMensagens ( chamadoId )
    {
        return $ctrl.mensagensRequest = Chat.mensagens().get({ chamadoId: chamadoId }, function( mensagens ){
            $ctrl.mensagens = mensagens;

            $ctrl.total = mensagens.length;

            $ctrl.buscandoMensagens = false;

            return true;
        }, function () {
            $ctrl.mensagens = [];

             $ctrl.buscandoMensagens = false;
        }).$promise;
    }

    /**
     * Envia uma respsota
     * 
     * @param {object} resposta 
     */
    function responder( resposta )
    {
        $ctrl.atualizar = false;

        var formResposta = new FormData();

        formResposta.append( 'mensagem', _.escape(resposta.mensagem.replace(/'/g, '"')) );

        _.each( resposta.anexos , function (anexo) {
            formResposta.append('Files[]', anexo, anexo.nome);
        });

        Chat.resposta( { chamadoId: $ctrl.chamadoId, origemParticipante: $ctrl.origem } ).enviar( 
            formResposta, 
            function( mensagem ){
                $ctrl.mensagens.unshift( mensagem );

                $ctrl.resposta = { anexos: [] };

                $ctrl.respondido({
                    mensagem: mensagem
                });

                $ctrl.exibirForm = false;
            }, 
            function(error){
                'error'
            }
        )
    } 

        
    /**
     * Ouvinte para o evento colar no formulario
     * de abertura de chamado
     * 
     * @param object $event
     */
    function colar($event) {
        Event.fire( 'anexo.colar-arquivo', $event );
    }

}


/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atendente__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atendente___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__atendente__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__solicitante__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__solicitante___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__solicitante__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_css__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_css__);





/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {


angular.module('app.components').component('chatSolicitante', {
    bindings: {
        chamado: '=',
        origem: '=',
        total: '=?',
        permitirResposta: '=',
        respondido: '&?'
    },
    controller: discussaoCtrl,
    template: __webpack_require__(277)
});

discussaoCtrl.$inject = ['$scope', 'Chat', 'notificacao', 'Event', 'Usuario', 'categorizacoesApi']

function discussaoCtrl ($scope, Chat, notificacao, Event, Usuario, categorizacoesApi) 
{
    var $ctrl = this;

    $ctrl.mensagens = [];  
    $ctrl.resposta = { anexos: [] };
    $ctrl.buscarMensagens = buscarMensagens;
    $ctrl.responder = responder;
    $ctrl.colar = colar;
    $ctrl.chamadoId = null;
    $ctrl.credencial = {};
    $ctrl.situacoes = [];
    $ctrl.buscandoMensagens = true;
    $ctrl.atualizar = true;
    $ctrl.exibirForm = false;

    Event.on('chat:atualizar', function(event, payload){
        if( payload.chamadoId && $ctrl.chamadoId == $ctrl.chamadoId  && $ctrl.atualizar){
            $ctrl.buscarMensagens( $ctrl.chamadoId ).then(function(){
                $ctrl.respondido()
            });
        }
        $ctrl.atualizar = true;
    })($scope)

    /**
     * Obtém a credencial do usuário logado
     */
    Usuario.credencial().then(function ( perfil ) {
        $ctrl.credencial = perfil.data.credencial;
    });

    $ctrl.$onInit = function()
    {
        $ctrl.chamado.then(function(chamado){
            $ctrl.chamadoId = chamado.chamadoId;

            // Indica que as mensagens estão sendo buscadas
            $ctrl.buscandoMensagens = true;

            $ctrl.buscarMensagens( chamado.chamadoId )
        });

        $ctrl.origem = $ctrl.origem || 0;

        // Indica a quantidade de mensagens
        $ctrl.total = $ctrl.total || 0;
    }

    /**
     * Busca as mensagens do chamado
     * 
     * @param {string} chamadoId 
     */
    function buscarMensagens ( chamadoId )
    {
        return $ctrl.mensagensRequest = Chat.mensagens().get({ chamadoId: chamadoId }, function( mensagens ){
            $ctrl.mensagens = mensagens;

            $ctrl.total = mensagens.length;

            $ctrl.buscandoMensagens = false;

            return true;
        }, function(){
             $ctrl.mensagens = [];

             $ctrl.buscandoMensagens = false;
        }).$promise;
    }


    /**
     * Envia uma respsota
     * 
     * @param {object} resposta 
     */
    function responder( resposta )
    {
        $ctrl.atualizar = false;

        var formResposta = new FormData();

        formResposta.append( 'mensagem', _.escape(resposta.mensagem.replace(/'/g, '"')) );

        _.each( resposta.anexos , function (anexo) {
            formResposta.append('Files[]', anexo, anexo.nome);
        });

        if(resposta.situacao && resposta.situacao.chamadoSituacaoId ){
            formResposta.append(
                'chamadoSituacaoRespostaSolicitanteId', 
                resposta.situacao.chamadoSituacaoId
            )
        }

        Chat.resposta( { chamadoId: $ctrl.chamadoId, origemParticipante: $ctrl.origem } ).enviar( 
            formResposta, 
            function( mensagem ){
                $ctrl.mensagens.unshift( mensagem );

                $ctrl.resposta = { anexos: [] };

                $ctrl.respondido({
                    mensagem: mensagem
                })

                $ctrl.exibirForm = false;
            }, 
            function(error){
                console.log(error)
            }
        )
    } 

        
    /**
     * Ouvinte para o evento colar no formulario
     * de abertura de chamado
     * 
     * @param object $event
     */
    function colar($event) {
        Event.fire( 'anexo.colar-arquivo', $event );
    }

}


/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__credencial_usuario_css__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__credencial_usuario_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__credencial_usuario_css__);
﻿

var centralApp = angular.module('app.components');

centralApp.component('credencialUsuario', {
    bindings: {
        credencial: '='
    },
    controller: credencialUsuarioCtrl,
    template: __webpack_require__(278)
});

credencialUsuarioCtrl.$inject = ['$sessionStorage', 'Usuario', 'ConfigApp'];
function credencialUsuarioCtrl($sessionStorage, Usuario, ConfigApp) 
{
    var $ctrl = this;

    Usuario.credencial().then(function ( perfil ) {
        var credencial = perfil.data.credencial;

        credencial.foto = ConfigApp.LinkFoto( credencial.usuario )

        $ctrl.credencial = credencial;
    });

    $ctrl.$onInit = function(){
        $ctrl.credencial = $ctrl.credencial || {};
    }
}

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__img_usuario_directive_css__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__img_usuario_directive_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__img_usuario_directive_css__);


var centralApp = angular.module('app.components');

centralApp.directive('imgUsuario', imgUsuarioFunc);

imgUsuarioFunc.$inject = ['ConfigApp']

function imgUsuarioFunc(ConfigApp)
{
    var semImg = {};

    return {
        link: function($scope, $element, $attr)
        {
            var name = 'src',
                //foto = ConfigApp.LinkFoto,
                padrao = __webpack_require__(133);

            $element.on('error', function(){
                semImg[$attr.imgUsuario] = true

                $element.prop(name, $attr['img-padrao'] || padrao);
            })

            $attr.$observe('imgUsuario', function(usuario)
            {
                //deixar sempre a foto padrão
                // if (semImg[$attr.imgUsuario]) {
                //     $attr.$set(name, $attr['img-padrao'] || padrao)

                //     return
                // }
                
                $attr.$set(name, $attr['img-padrao'] || padrao)
                // $attr.$set(name, foto( usuario ))
            })

        }
    }
}

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
﻿

var centralApp = angular.module('app.components');

centralApp.directive('lerArquivo', lerArquivoFunc);


lerArquivoFunc.$inject = ['$q'];

function lerArquivoFunc($q) {
    var slice = Array.prototype.slice;

    return {
        restrict: 'A',
        require: '?ngModel',
        scope: {
            carregado: '=?' 
        },
        link: function (scope, element, attrs, ngModel) {
            if (!ngModel) return;

            ngModel.$render = function () { };

            element.bind('change', function (e) {
                var element = e.target;

                $q.all(_.map(element.files, readFile))
                    .then(function (values) {
                        if (element.multiple) ngModel.$setViewValue(values);
                        else ngModel.$setViewValue(values.length ? values[0] : null);
                    });

                function readFile(file) {

                    if (!scope.carregado) return file;

                    var deferred = $q.defer();

                    var reader = new FileReader();
                    reader.onload = function (e) {
                        deferred.resolve(e.target.result);
                    };
                    reader.onerror = function (e) {
                        deferred.reject(e);
                    };
                    reader.readAsDataURL(file);

                    return deferred.promise;
                }

            });

        }
    };
}

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.components').directive('listaSituacoes', listaSituacoesFunc);

listaSituacoesFunc.$inject = ['ConfigApp']

function listaSituacoesFunc(ConfigApp) {
    return {
        require: '^ngModel',
        restrict: 'E',
        scope: {},
        controllerAs: '$ctrl',
        controller: ['$scope', 'categorizacoesApi',
        function ($scope, categorizacoesApi) {

            var $ctrl = this;

            $ctrl.situacoes = [];
            $ctrl.situacao = {};
            $ctrl.ngModel = {};

            $ctrl.$onInit = function () {
                categorizacoesApi.listarSituacoesEncerramento(function (situacoes) {
                    $ctrl.situacoes = situacoes;
                }, function () {
                    $ctrl.situacoes = [];
                })
            }

            $ctrl.setNgModel = function (ngModel) {
                $ctrl.ngModel = ngModel;

                $ctrl.ngModel.$render = $ctrl.definitSituacao;
            }

            $ctrl.definitSituacao = function (situacao) {
                $ctrl.situacao = situacao;
            }

            $ctrl.selecionarSituacao = function (situacao) {
                $ctrl.ngModel.$setViewValue(situacao);

                $ctrl.ngModel.$render(situacao)
            }

        }],
        link: function ($scope, $element, $attr, $ngModelctrl) {
            $scope.$ctrl.setNgModel($ngModelctrl)
        },
        template: __webpack_require__(279)
    }
}


/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__painel_component_css__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__painel_component_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__painel_component_css__);
﻿

var centralApp = angular.module('app.components');

centralApp.component('painel', {
    bindings: {
        titulo: '@',
        icone: '@?',
        subtitulo: '@?',
        ngClass: '=?'
    },
    replace: true, 
    transclude: true,
    template: __webpack_require__(280)
});


/***/ }),
/* 317 */
/***/ (function(module, exports) {

angular.module('app.components')

    .directive('previewImage', previewImageFunc);

function previewImageFunc() {
    return {
        template: '<canvas>Carregando imagem...</canvas>',
        scope: {
            src: '='
        },
        link: function ($scope, $element, $attrs) {
            var $el =  $element, $parent = $el.parent()[0];
            var canvas = $element.find('canvas')[0];

            var gkhead = new Image;

            setTimeout(init, 100)
            
            gkhead.src = $scope.src.toString();

            function init () {

                canvas.width = $parent.clientWidth - 35;
                canvas.height = $parent.clientHeight - 35;

                var ctx = canvas.getContext('2d');
                trackTransforms(ctx);

                function redraw() {
                    // Clear the entire canvas
                    var p1 = ctx.transformedPoint(0, 0);
                    var p2 = ctx.transformedPoint(canvas.width, canvas.height);
                    ctx.clearRect(p1.x, p1.y, p2.x - p1.x, p2.y - p1.y);

                    ctx.save();
                    ctx.setTransform(1, 0, 0, 1, 0, 0);
                    ctx.clearRect(0, 0, canvas.width, canvas.height);
                    ctx.restore();

                    ctx.drawImage(
                        gkhead,
                        (gkhead.width < canvas.width ? (canvas.width / 2) - (gkhead.width / 2) : 0 ), 
                        (gkhead.height < canvas.height ? (canvas.height / 2) - (gkhead.height / 2) : 0 ),
                        (gkhead.width > canvas.width ? canvas.width : gkhead.width), 
                        (gkhead.height > canvas.height ? canvas.height : gkhead.height)
                    );

                }
                redraw();

                var lastX = canvas.width / 2, lastY = canvas.height / 2;

                var dragStart, dragged;

                canvas.addEventListener('mousedown', function (evt) {
                    document.body.style.mozUserSelect = document.body.style.webkitUserSelect = document.body.style.userSelect = 'none';
                    lastX = evt.offsetX || (evt.pageX - canvas.offsetLeft);
                    lastY = evt.offsetY || (evt.pageY - canvas.offsetTop);
                    dragStart = ctx.transformedPoint(lastX, lastY);
                    dragged = false;
                }, false);

                canvas.addEventListener('mousemove', function (evt) {
                    
                    $el.css({'cursor': 'move'})

                    lastX = evt.offsetX || (evt.pageX - canvas.offsetLeft);
                    lastY = evt.offsetY || (evt.pageY - canvas.offsetTop);
                    dragged = true;
                    if (dragStart) {
                        var pt = ctx.transformedPoint(lastX, lastY);
                        ctx.translate(pt.x - dragStart.x, pt.y - dragStart.y);
                        redraw();
                    }
                }, false);

                canvas.addEventListener('mouseup', function (evt) {
                    dragStart = null;
                    if (!dragged) zoom(evt.shiftKey ? -1 : 1);
                }, false);

                var scaleFactor = 1.1;

                var zoom = function (clicks) {

                    if(clicks > 0){
                        $el.css({'cursor': '-webkit-zoom-in'})
                    } else {
                        $el.css({'cursor': '-webkit-zoom-out'})
                    }

                    var pt = ctx.transformedPoint(lastX, lastY);
                    ctx.translate(pt.x, pt.y);
                    var factor = Math.pow(scaleFactor, clicks);
                    ctx.scale(factor, factor);
                    ctx.translate(-pt.x, -pt.y);
                    redraw();

                }

                var handleScroll = function (evt) {
                    var delta = evt.wheelDelta ? evt.wheelDelta / 40 : evt.detail ? -evt.detail : 0;
                    if (delta) zoom(delta);
                    return evt.preventDefault() && false;
                };

                canvas.addEventListener('DOMMouseScroll', handleScroll, false);
                canvas.addEventListener('mousewheel', handleScroll, false);
            };

            // Adds ctx.getTransform() - returns an SVGMatrix
            // Adds ctx.transformedPoint(x,y) - returns an SVGPoint
            function trackTransforms(ctx) {
                var svg = document.createElementNS("http://www.w3.org/2000/svg", 'svg');
                var xform = svg.createSVGMatrix();
                ctx.getTransform = function () { return xform; };

                var savedTransforms = [];
                var save = ctx.save;
                ctx.save = function () {
                    savedTransforms.push(xform.translate(0, 0));
                    return save.call(ctx);
                };

                var restore = ctx.restore;
                ctx.restore = function () {
                    xform = savedTransforms.pop();
                    return restore.call(ctx);
                };

                var scale = ctx.scale;
                ctx.scale = function (sx, sy) {
                    xform = xform.scaleNonUniform(sx, sy);
                    return scale.call(ctx, sx, sy);
                };

                var rotate = ctx.rotate;
                ctx.rotate = function (radians) {
                    xform = xform.rotate(radians * 180 / Math.PI);
                    return rotate.call(ctx, radians);
                };

                var translate = ctx.translate;
                ctx.translate = function (dx, dy) {
                    xform = xform.translate(dx, dy);
                    return translate.call(ctx, dx, dy);
                };

                var transform = ctx.transform;
                ctx.transform = function (a, b, c, d, e, f) {
                    var m2 = svg.createSVGMatrix();
                    m2.a = a; m2.b = b; m2.c = c; m2.d = d; m2.e = e; m2.f = f;
                    xform = xform.multiply(m2);
                    return transform.call(ctx, a, b, c, d, e, f);
                };

                var setTransform = ctx.setTransform;
                ctx.setTransform = function (a, b, c, d, e, f) {
                    xform.a = a;
                    xform.b = b;
                    xform.c = c;
                    xform.d = d;
                    xform.e = e;
                    xform.f = f;
                    return setTransform.call(ctx, a, b, c, d, e, f);
                };

                var pt = svg.createSVGPoint();
                ctx.transformedPoint = function (x, y) {
                    pt.x = x; pt.y = y;
                    return pt.matrixTransform(xform.inverse());
                }
            }

        }
    }
}



/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_css__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_css__);


angular.module('app.components')

.component('redirecionamentos', {
   bindings: {
       redirecionamentos: '=',
       de: '='
   },
   template: __webpack_require__(281)
})

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.components').component('segmentoSelecionado', {
    bindings: {
        parametros: '='
    },
    transclude: true,
    controllerAs: '$ctrl',
    controller: segmentoSelecionadoCtrl,
    template: __webpack_require__(282)
});

segmentoSelecionadoCtrl.$inject = ['$sessionStorage', 'segmentosApi', 'notificacao'];
function segmentoSelecionadoCtrl($sessionStorage, segmentosApi, notificacao) {
    var $ctrl = this;

    $ctrl.exibir = { segmento: null, credencial: null };

    $ctrl.$onInit = function(){
        if (_.has($ctrl.parametros, '$$state')) {
            $ctrl.parametros.then(function (chamado) {
                obterDadosChamado({
                    grupoDeSuporteId: chamado.grupoDeSuporteSegmento.grupoDeSuporte.grupoDeSuporteId,
                    grupoDeSuporteSegmentoId: chamado.grupoDeSuporteSegmento.grupoDeSuporteSegmentoId
                });
            });
        } else {
            obterDadosChamado($ctrl.parametros);
        }
    }

    function obterDadosChamado(parametros) {
        segmentosApi.lerDadosChamado(parametros, function (segmentoSelecionado) {
            $ctrl.exibir = {
                segmento: segmentoSelecionado,
                credencial: $sessionStorage.credencial.data
            };
        }, function error(errorResponse) {
            notificacao.erroResponse(errorResponse);
        });
    }
}

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
﻿

var centralApp = angular.module('app.components');

centralApp.component('tempoDecorrido', {
    bindings: {
        data: '=',
        real: '=?'
    },
    controllerAs: '$ctrl',
    controller: tempoController,
    template: '<span ng-bind="$ctrl.tempo"></span>'
});

tempoController.$inject = ['$interval', '$filter'];
function tempoController($interval, $filter) {

    var $ctrl = this;

    $ctrl.tempo = $filter('tempoDecorrido')($ctrl.data);

    if ($ctrl.real) {
        $interval(function () {
            $ctrl.tempo = $filter('tempoDecorrido')($ctrl.data);
        }, 1000);
    }
}


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var centralApp = angular.module('app.components');

centralApp.component('versao', {
    controllerAs: '$ctrl',
    controller: versaoSistemaCtrl,
    template: '<i class="fa fa-anchor" aria-hidden="true"></i> <i ng-bind="$ctrl.versao"></i>'
});

versaoSistemaCtrl.$inject = ['sistemaApi'];
function versaoSistemaCtrl(sistemaApi) {
    var $ctrl = this;

    sistemaApi.versao().then(function (response) {
        console.log(response);
        $ctrl.versao = response;
    });
}

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
﻿

var centralApp = angular.module('app.components');

centralApp.directive('visualizarArquivo', function () {

    return {
        restrict: 'A',
        scope: {
            arquivo: '=visualizarArquivo'
        },
        controllerAs: '$ctrl',
        controller: visualizarArquivoCtrl,
        link: function ($scope, $element, $attr) {

            $element.bind('click', function (e) {
                e.preventDefault();

                if ($scope.arquivo instanceof File || $scope.arquivo instanceof Blob) {

                    // Ler o arquivo de imagem
                    $scope.lerArquivo($scope.arquivo).then(function (base64) {
                        $scope.exibirImagem($scope.arquivo, base64);
                    });

                } else {
                    $scope.baixarArquivo();
                }

            });

        }
    }

});

visualizarArquivoCtrl.$inject = ['$scope', '$q', '$modal', 'notificacao', 'anexoApi'];

function visualizarArquivoCtrl($scope, $q, $modal, notificacao, anexoApi) {

    var $ctrl = $scope;

    $ctrl.baixarArquivo = baixarArquivo;
    $ctrl.lerArquivo = lerArquivo;
    $ctrl.exibirImagem = exibirImagem;


    /**
     * Realiza uma consulta na api para baixar 
     * o arquivo solicitado
     */
    function baixarArquivo() {
        $ctrl.arquivo.abrindo = true;
        anexoApi.baixarArquivo($ctrl.arquivo, function (resposta) {
            
            // Cria a instância do arquivo
            var arquivo = new Blob([resposta.data], {
                type: resposta.headers['content-type']
            });

            // Ler o arquivo de imagem
            $ctrl.lerArquivo(arquivo).then(function (base64) {
                $ctrl.src = base64;
                $ctrl.exibirImagem($ctrl.arquivo, base64);
            });

            $scope.arquivo.abrindo = false;
        }, function (error) {
            notificacao.erro('Houve um erro ao baixar o arquivo');
            $scope.arquivo.abrindo = false;
        });
    }

    /**
     * Ler o conteúdo do arquivo
     * 
     * @param Blob arquivo
     * 
     * @return $promise
     */
    function lerArquivo(arquivo) {

        var deferred = $q.defer();

        var reader = new FileReader();
        reader.onload = function (e) {
            deferred.resolve(e.target.result);
        };

        reader.onerror = function (e) {
            deferred.reject(e);
        };

        reader.readAsDataURL(arquivo);

        return deferred.promise;
    }

    /**
     * Responsável por aprensentar a modal
     * com a imagem
     * 
     * @param string base64(imagem)
     */
    function exibirImagem(arquivo, base64) {

        $modal({
            title: arquivo.arquivoNome || arquivo.name || 'Imagem',
            content: base64,
            scope: $ctrl,
            html: true,
            show: true,
            backdrop: true,
            template: __webpack_require__(283),
            onHide: function () {
                $('body').removeClass('modal-open')
            }
        });

    }
}

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;

function install ( mod ) {

    /**
     * Este filtro nos fornece o tempo em dias horas minutos 
     * e segundos em relação a data que foi passada por paramentro.
     * 
     * @param {object} data
     */
    mod.filter('tempoDecorrido', ['$filter', function ($filter) {
        return function (data) {

            // Define o locale
            moment.locale('pt-br');

            // Cria uma instância da data
            var dataInicial = moment(data);

            // Verifica se é uma data válida
            if (!dataInicial.isValid()) return;

            // Retorna o tempo decorrido
            return moment.duration(moment().diff(dataInicial))
                        .humanize();

        };
    }])

    /**
     * Verifica se um item existe na coleção
     * 
     * @param {object} data
     */
    mod.filter('tem', [function () {
        return function (colecao, item, retornoTrue, retornoFalse) {

            var tem = !!_.filter(colecao, function (i) {
                return i == item;
            }).length;

            if (retornoTrue && retornoFalse) {
                return tem ? retornoTrue : retornoFalse;
            }

            return tem;

        };
    }])

    /**
     * Limita uma sequencia de caracteres
     * 
     * @param {string} texto
     */
    mod.filter('limitar', [function() {
        return function ( texto, tamanho, borda ) {

            tamanho = tamanho || 100;
            borda = borda || '...';

            if (tamanho && texto.length > tamanho) {
                return texto.slice(0, tamanho) + borda;
            }

            return texto;
        };
    }])

    /**
     * Limpa um determinado texto de tags html
     * [trocar o nome do filtro por um nome mais sugestivo]
     * 
     * @param {string} texto
     */
    mod.filter('htmlLimpo', ['$filter', function ($filter) {
            return function (html, tamanho) {
                var texto = html ? String(html).replace(/<[^>]+>/gm, '').replace(/&nbsp;/gm, ' ') : ' ';

                return $filter('limitar')( texto, tamanho );
            };
        }
    ])

    /**
     * Exibe a dimensão do arquivo
     * 
     * @param {object} dimensao
     */
    mod.filter('dimensaoArquivo', [function () {
        return function (bytes, decimals) {
            if (!bytes) {
                return '';
            } else if (bytes == 0) {
                return '0 Byte'
            };
            var k = 1000;
            var dm = decimals + 0 || 3;
            var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
            var i = Math.floor(Math.log(bytes) / Math.log(k));
            return (parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]) || '';
        }
    }])

    /**
     * Busca itens de forma recurso em uma coleção
     * de itens ou um objeto segmentado.
     * 
     * @param input (object|date)
     */
    mod.filter('buscar', ['$filter', function buscarFtr($filter) {
        return function (colecao, procudado) {
            function fn(colecao, procudado) {
                var find = _.find(colecao, procudado);
                if (find) return [find];
                return _.flatten(_.map(colecao, function (v) {
                    return typeof v == "object" ? fn(v, procudado) : [];
                }), true);
            }
            return fn(colecao, procudado);
        };
    }])

    mod.filter('toArray', function () {
        return function (object) {
            return _.values(object)
        }
    } )

}

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */


function install ( mod ) 
{
    mod.events = mod.events || []

    mod.config(['$provide', function($provide){
        
        $provide.decorator('$rootScope', ['$delegate', function($delegate){
            var Scope = $delegate.constructor;
            var origBroadcast = Scope.prototype.$broadcast;
            var origEmit = Scope.prototype.$emit;

            function pushEvent(event){
                (mod.events[event] || (mod.events[event] = [])).push(new Date())
            }

            Scope.prototype.$broadcast = function(){
                pushEvent(arguments[0])
                return origBroadcast.apply(this, arguments)
            }

            Scope.prototype.$emit = function(){
                pushEvent(arguments[0])
                return origEmit.apply(this, arguments)
            }

            return $delegate

        }])

    }])
}

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;


function install ( mod ) 
{
    mod.directive('expandMenu', function () {

        return {
            restrict: 'A',
            link: function ($scope, $element) {
                // Obtém o menu
                var menu = $($element[0])

                // Adciona o evento click nos links
                menu.find('a').on('click', function( event ) {

                    // Seleciona o menu do contexto
                    var li = $(event.target).parent()

                    if (li.is('.in')) {

                        li.removeClass('in')

                        $('ul:first', li).slideUp(100)

                    } else {

                        li.addClass('in')

                        $('ul:first', li).slideDown(100)
                    }

                })
                
                // Essa trigger é temporaria, deve ser removida
                // na versão futura desta aplicação
                .trigger('click')
            }
        }

    })
}

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;


function install ( mod, prefix ) 
{
    prefix = prefix || '';

    mod.directive(_.camelCase(prefix + 'ExibirDurante'), function () {
        return {
            restrict: 'A',
            controller: ['$scope', '$localStorage', function($scope, $localStorage){

                $scope.$storage = $localStorage.$default({})
                
            }],
            link: function($scope, $element, $attrs){

                var id = $attrs.id;
                var target = _.camelCase('exibir-'+id);

                if(id) {

                    if(!$scope.$storage[target]) {
                        $scope.$storage[target] = moment().add($attrs.dias | 2, 'days')
                    } else {
                        if (moment($scope.$storage[target]).isBefore(new Date())) {
                            $element.css({ display: 'none' })
                        } else {
                            $attrs.$set('title', 'Este aviso será removido ' + moment().to($scope.$storage[target]))
                            $element.css({ display: 'inline-block' })
                        }
                    }

                }


            }
        }
    })

    mod.directive(_.camelCase(prefix + 'Odometer'), [function () {
        return {
            restrict: 'A',
            scope: { valor: '=' },
            link: function ($scope, $el, $attrs) {
                var opts, odometer;

                opts = $scope.$eval($attrs.options) || {}
                opts.el = $el[0]
                odometer = new Odometer(opts);

                $scope.$watch('valor', function (valor) {
                    odometer.update(valor)
                }, true)

            }
        }
    }])

    mod.directive(_.camelCase(prefix + 'Scroll'), ['Event', function(Event) {

        var cache = {};

        const isChrome = typeof chrome !== 'undefined' && chrome.webstore

        return {
            restrict: 'A',
            link: function ($scope, $element, $attrs) {

                var key = "scroll-" + ($attrs.id || 'position');

                var body = document.body,
                    html = document.documentElement,
                    top = 0, scrollTotal = 0, parte = 0,
                    height = 0;

                Event.on('window.resize', function () {
                    resize()

                    setTimeout(function () {
                        $scope.$digest()
                    }, 100)
                })

                function resize () {

                    height = window.innerHeight;

                    $($element).css({
                        'height': (height - $element[0].offsetTop - 120 + (parseInt($attrs.offset || 0)) ) + 'px',
                        'overflow': isChrome ? 'overlay' : 'auto'
                    }).ready(function () {

                        $($element).stop().animate({
                              scrollTop: cache[key]
                        }, 1200, 'swing' );

                    });
                }

                $($element).scroll(function () {

                    top = $($element).scrollTop();
                    scrollTotal =$element[0].scrollHeight;
                    scrollTotal = scrollTotal - (scrollTotal  * 0.18); // tamanho total de scroll
                    parte = scrollTotal - ( scrollTotal * 0.10 ); // parte do scroll

                    // 6 <- top - posicao atual
                    // 10 <- scroll total
                    // 10 - (10 * 0.10) = 9
                    // 6 > 9

                    if (top > parte ) {
                        Event.emit('scroll:final')
                    }

                    cache[key] = top;

                    if (top > 0) {
                        $element.css({
                            'border-top': '4px solid #e8e8e8',
                            'border-botton': '1px solid #e8e8e8'
                        });
                    } else {
                        $element.css({
                            'border-top': 'none',
                            'border-botton': 'none'
                        });
                    }
                });
                                
                window.addEventListener('resize', _.debounce(function(){
                    resize()

                    $scope.$digest()
                }), 100);

                resize()

            }
        }
    }])

    var isActive = false;   
    mod.directive(_.camelCase(prefix + 'CapsLock'), function () {
        return {
            restrict: 'A',
            link: function ($scope, $elem, $attrs) {

                var $target = '.' + ($attrs.target || 'icon-caps-lock')

                $(document).bind("keydown", function (event) {
                    if (event.keyCode === 20 ) { 
                        capsLock(!isActive); 
                    }
                });

                $(document).bind("keypress", function (event) {
                    var code = event.charCode || event.keyCode;
                    var shift = event.shiftKey;

                    if (code > 96 && code < 123) { capsLock(false); }
                    if (code > 64 && code < 91 && !shift) { capsLock(true); }
                });

                function capsLock (visible) {
                    if (visible) {
                        $($target).show()
                    } else {
                        $($target).hide()
                    }

                    isActive = visible;
                }
                
            }
        }
    })

}



/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.services')

.service('Event', eventoService)
.service('Evento', eventoService); // Atalho

eventoService.$inject = ['$rootScope'];
function eventoService($rootScope) {

    /**
     * Dispara um evento
     */
    this.fire = function (/* event, arguments */)
    {
        $rootScope.$broadcast.apply($rootScope, arguments);

        return this;
    }

    /**
     * Dispara um evento
     */
    this.emit = function (/* event, arguments */) {
        this.fire.apply(this, arguments)
    }

    /**
     * Adiciona um ouvite para um determinado evento.
     * 
     * - Adicionando ouvinte globais
     * Event.on('meu:evento', function(){})
     * 
     * - Adicionando ouvinte locais
     * Event.on('meu:evento', function(){})($scope)
     * 
     * @param {string} event
     * @param {function} handler
     * @return {function} 
     */
    this.on = function (event, handler)
    {
        var removeListener = $rootScope.$on(event, handler);

        return function ($scope) {
            ($scope || $rootScope).$on('$destroy', function(){
                removeListener()
            })
        };
    }

    /**
     * Adicioan um ouvinte para ser disparado apenas uma
     * vez. Isso irá remover o ouvite após o evento ser 
     * disparado.
     * 
     * - Adicionando ouvinte globais
     * Event.on('meu:evento', function(){})
     * 
     * - Adicionando ouvinte locais
     * Event.on('meu:evento', function(){})($scope)
     * 
     * @param {string} event
     * @param {function} handler
     */
    this.once = function(event, handler)
    {
        var removeListener = $rootScope.$on(event, function(){

            handler.apply(this, arguments)

            removeListener()
        })

        return function ($scope) {
            ($scope || $rootScope).$on('$destroy', function(){
                removeListener()
            })
        };
    }

}

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var centralApp = angular.module('app.services');

// Serviço de notificação
centralApp.factory('notificacao', notificacaoSrv);

notificacaoSrv.$inject = ['$alert', '$notification', '$window'];
function notificacaoSrv($alert, $notification, $window) {

    return {

        driver: 'toastr',

        opcoes: {},

        duracao: 5,

        /**
        * Exibe mensagens fomatadas na visão de erro. 
        * As mensagens são disparadas pelo domínio da 
        * aplicação através de serviços RESTful.
        * 
        * @param object response
        */
        erroResponse: function (response) {
            if (response.status === 500) {
                this.com('toastr').erro('Erro', 'Ocorreu um erro, tente novamente');
            } else {
                _.each(_.get(response, 'data.errors', []),function (error) {
                    this.erro(error.key, error.value)
                }.bind(this))
            }
        },

        /**
         * Fornece um meio para selecionar
         * qual drive será responsável por 
         * dispara a notificação
         */
        com: function (driver, callback) {
            this.driver = driver || this.driver;

            return this;
        },

        /**
         * Informa quanto tempo a notificação deve
         * ficar ativa
         */
        durante: function (segundados) {
            this.duracao = segundados;

            return this;
        },

        /**
         * Notificação de sucesso
         */
        sucesso: function (titulo, mensagem, opcoes) {
            this.notificar({
                titulo: titulo, 
                mensagem: mensagem,
                tipo: 'success',
                opcoes: opcoes
            });
        },

        /**
         * Notificação de alerta
         */
        alerta: function (titulo, mensagem, opcoes) {
            this.notificar({
                titulo: titulo,
                mensagem: mensagem,
                tipo: 'warning',
                opcoes: opcoes
            });
        },

        /**
         * Notificação de alerta
         */
        aviso: function (titulo, mensagem, opcoes) {
            this.notificar({
                titulo: titulo,
                mensagem: mensagem,
                tipo: 'warning',
                opcoes: opcoes
            });
        },

        /**
         * Notificação de informação
         */
        info: function (titulo, mensagem, opcoes) {
            this.notificar({
                titulo: titulo,
                mensagem: mensagem,
                tipo: 'info',
                opcoes: opcoes
            });
        },

        /**
         * Notificação de erro
         */
        erro: function (titulo, mensagem, opcoes) {
            this.notificar({
                titulo: titulo,
                mensagem: mensagem,
                tipo: 'error',
                opcoes: opcoes
            });
        },

        /**
         * Notificação de negado
         */
        negado: function (titulo, mensagem, opcoes) {
            this.erro(titulo, mensagem, opcoes);
        },

        /**
         * Dispara notificação
         * 
         * Exemplo: Notificacao.notificar({
         *      titulo: 'Importante',
         *      mensagem: 'Verifique suas atualizações',
         *      tipo: 'alerta',
         *      driver: 'desktop'
         * });
         */
        notificar:  function(notificacao){

            if (_.isUndefined(notificacao.mensagem)) {
                notificacao.mensagem = notificacao.titulo;

                notificacao.titulo = '';
            }

            // Normaliza algumas propriedades
            notificacao.tipo    = _.get(notificacao, 'tipo', 'warning');
            notificacao.driver  = _.get(notificacao, 'driver', this.driver);
            notificacao.opcoes  = _.get(notificacao, 'opcoes', this.opcoes);

            switch (notificacao.tipo ){
                case 'info': 
                     notificacao.duracao = 10;
                    break;
                case 'success':
                     notificacao.duracao = 5;
                    break;
                case 'warning': 
                     notificacao.duracao = 10;
                    break;
                case 'error':
                case 'danger':
                     notificacao.duracao = 15;
                    break;
                default :
                     notificacao.duracao = 3;
            }

            var driver = this.normalizarDriver(notificacao.driver);

            try {

                // Dispara notificação
                this[driver](notificacao);

            } catch(e){

                console.error('Houve um erro ao construir o driver de notificação!', e);

            }

            // Reseta driver
            this.driver = 'toastr';

        },

        /**
         * Dispara notificação
         * 
         * @param string titulo
         * @param string mensagem
         * @param string driver
         */
        disparar: function (titulo, mensagem, driver) {
            this.notificar({
                titulo: titulo,
                mensagem: mensagem,
                driver: driver
            });
        },

        /**
         * Normaliza o nome do driver para ser criado
         * 
         * @param string driver
         */
        normalizarDriver: function(driver){
            return 'criar' + _.capitalize(driver) + 'Driver';
        },

        /**
         * Cria o dirver strap de notificação
         */
        criarStrapDriver: function (notificacao) {
            
            $alert(_.merge({
                title: notificacao.titulo,
                type: notificacao.tipo,
                content: notificacao.mensagem,
                duration: notificacao.duracao,
                animation: 'am-fade-and-slide-top',
                placement: 'top-right',
                show: true
            }, notificacao.opcoes));

        },

        /**
         * Cria o dirver toastr de notificação
         */
        criarToastrDriver: function (notificacao) {

            notificacao.opcoes = {
                closeButton: true,
                debug: false,
                newestOnTop: true,
                progressBar: true,
                positionClass: "toast-top-center",
                preventDuplicates: true,
                showDuration: "300",
                hideDuration: "1000",
                extendedTimeOut: "1000",
                showEasing: "swing",
                hideEasing: "linear",
                showMethod: "fadeIn",
                hideMethod: "fadeOut",
                timeOut: (notificacao.duracao || 5) * 1000
            };

            toastr[notificacao.tipo](
                notificacao.mensagem, 
                notificacao.titulo, 
                notificacao.opcoes
            );

        },

        /**
         * Cria o dirver desktop de notificação
         */
        criarDesktopDriver: function (notificacao) {

            var self = this;

            $notification.requestPermission().then(function (permissao) {

                if (permissao === 'granted') {
                    $notification(notificacao.titulo, {
                        body: notificacao.mensagem,
                        focusWindowOnClick: true,
                        delay: notificacao.duracao * 1000,
                        icon: notificacao.imagem || __webpack_require__(133),
                        tag: _.kebabCase(notificacao.mensagem)
                    });
                } else if (permissao === 'denied') {
                    self.sucesso(notificacao.titulo, notificacao.mensagem, 'toastr');
                }

            })

        }

    }
}

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.services')
.service('NotificacaoStream', NotificacaoStream);

NotificacaoStream.$inject = ['$rootScope', 'ConfigApp', 'Event', '$q'];

function NotificacaoStream ($rootScope, ConfigApp, Event, $q)
{
    var connection = $.hubConnection(ConfigApp.UrlBase);
    var hubProxy = connection.createHubProxy('notificacaoHub');
    var deferred = $q.defer();

    var registrados = [];

    /**
     * Adiciona ouvintes para serem disparados quando o 
     * evento for acionado
     * 
     * @param string evento
     * @param function handle
     */
    this.em = function(evento, manipulador)
    {
        hubProxy.on(evento, function () {
            var args = arguments;

            $rootScope.$apply(function () {
                manipulador.apply(this, args);
            });
        });

        return this;
    }

    /**
     * Adiciona ouvintes para serem disparados quando o 
     * evento for acionado.
     * 
     * @param args argumentos [event, handle]
     */
    this.ouvir = function(/* argunments */)
    {
        return this.em.apply(this, arguments);
    }

    /**
     * Abre um sockete de comunicação
     * com um canal especifico.
     * 
     * @param name
     */
    this.canal = function (nome)
    {
        if( !registrados[nome] ) {
            hubProxy.invoke('JoinGroup', nome).done( function(e){
                registrados.push(nome)
            });
        }

        return this;
    }

    /**
     * Abre um socket de comunicação
     * com um usuário especifico.
     * 
     * @param name
     */
    this.usuario = function( nome )
    {
        return this.canal(nome);
    }

    /**
     * Abre um sockete de comunicação com uma lista de
     * canais.
     * 
     * @param {array} canais 
     */
    this.canais = function ( canais )
    {
        var $this = this;

        canais.forEach(function (nome) {
            $this.canal (nome)
        })

        return $this;
    }

    /**
     * Conecta a aplicação 
     */
    this.conectar = function ()
    {
        connection 
        
        .start(function () {
            //deferred.resolve(arguments)
        })
        .done(function () {
            deferred.resolve(arguments)
        })
        .fail( function () {
            deferred.reject(arguments)
        });
        
        return deferred.promise;
    }
}


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var centralApp = angular.module('app.services');
centralApp.factory('segmentosApi', segmentosSrv);
segmentosSrv.$inject = ['$resource', 'ConfigApp'];

function segmentosSrv($resource, ConfigApp) {
    return $resource(ConfigApp.UrlApi + '/v1.0/segmentos',
        {  }, {
            listarSegmentos: {
                method: 'GET',
                isArray: true,
                url: ConfigApp.UrlApi + '/v1.0/segmentos/centrais_servico/' + ConfigApp.CentralServicoModuloId
            },
            lerDadosChamado: {
                method: 'GET',
                isArray: false,
                url: ConfigApp.UrlApi + '/v1.0/segmentos/dados_chamado/grupos_suporte/:grupoDeSuporteId/grupos_suporte_segmentos/:grupoDeSuporteSegmentoId'
            },
            listarSegmentosPorCanal: {
                method: 'GET',
                isArray: true,
                url: ConfigApp.UrlApi + '/v1.0/segmentos/grupos_suporte/:grupoDeSuporteId/canais_atendimento/:canalDeAtendimentoId',
                ignoreLoadingBar: true
            }
        });
};


/***/ }),
/* 331 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[173]);


// WEBPACK FOOTER //
// static/js/app.d4105ff6fec3c02725cc.js